(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[9391],{

/***/ 90927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ init)
/* harmony export */ });
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(469);
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92619);


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: _sentry_browser__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M,
      },
    ],
    version: _sentry_browser__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M,
  };
  (0,_sentry_browser__WEBPACK_IMPORTED_MODULE_1__/* .init */ .Ts)(options);
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 17462:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(95271),
    isArray = __webpack_require__(25874),
    isObjectLike = __webpack_require__(77583);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 84341:
/***/ (() => {

"use strict";
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 26841:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Aq: () => (/* binding */ schemaMetadataFileName),
/* harmony export */   DE: () => (/* binding */ getFrontendEnvVariables),
/* harmony export */   FB: () => (/* binding */ isExcludedNamespaceSegment),
/* harmony export */   Rm: () => (/* binding */ version1PathPreferences),
/* harmony export */   TW: () => (/* binding */ supportedViteConfigPaths),
/* harmony export */   Y3: () => (/* binding */ mockAppBridgeParam),
/* harmony export */   _q: () => (/* binding */ LogSource),
/* harmony export */   os: () => (/* binding */ globalActionsFolderPath),
/* harmony export */   qQ: () => (/* binding */ PermissionsLocation),
/* harmony export */   sc: () => (/* binding */ getPathPreferences)
/* harmony export */ });
/* unused harmony exports backendFolder, modelsFolderSegment, globalActionsFolderSegment, modelsFolderPath, aacPathPreferences, maybeFindViteConfigFilename, isLegacyViteConfigLocation, UNKNOWN_SHOPIFY_APP_URL, FrameworkPackageName, appBridgeCDNUrl */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67918);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

const backendFolder = "api/";
const modelsFolderSegment = "models/";
const globalActionsFolderSegment = "actions/";
const schemaMetadataFileName = "schema.gadget.ts";
const PermissionsLocation = "accessControl/permissions";
const modelsFolderPath = `${backendFolder}${modelsFolderSegment}`;
const globalActionsFolderPath = `${backendFolder}${globalActionsFolderSegment}`;
const isExcludedNamespaceSegment = (segment)=>{
    return segment[0] === "(" && segment[segment.length - 1] === ")";
};
const version1PathPreferences = {
    backendFolder,
    frontendFolder: "web/",
    shopifyExtensionsFolder: "extensions/",
    frontendRoutesFolder: "web/routes/",
    modelsFolderPath,
    globalActionsFolderPath,
    routesPath: "api/routes/",
    bootPluginsPath: "api/boot/",
    computedViewsPath: "api/views/",
    backendRouteFileRegex: /^\/?api\/routes\/((\/|[^[:*]*)\/)?GET(-?([^:[*]*)(\..+)?)?\.(js|ts)$/,
    getReactRouterTypeImportStatement: (routeFilePath)=>{
        const routeFilename = routeFilePath.split("/").pop()?.replace(/\.[^.]+$/, "");
        return `import type { Route } from "./+types/${routeFilename}";`;
    },
    getActionFilePath: (modelId, actionId, typescript)=>{
        return `${modelsFolderPath}${modelId}/actions/${actionId}.${typescript ? "ts" : "js"}`;
    },
    getActionFolderPath: (props)=>{
        const { namespacedModelApiId, schemaFilePath } = props;
        if (schemaFilePath && schemaFilePath.endsWith(schemaMetadataFileName)) {
            return schemaFilePath.slice(0, -schemaMetadataFileName.length) + "actions/";
        }
        return `${modelsFolderPath}${namespacedModelApiId}/actions/`;
    },
    getModelFilterFolder: (props)=>{
        const { filterPath, schemaFilePath } = props;
        if (schemaFilePath && schemaFilePath.endsWith(schemaMetadataFileName)) {
            return "accessControl/filters/" + schemaFilePath.slice(0, -schemaMetadataFileName.length).slice(modelsFolderPath.length);
        }
        return `accessControl/filters/${filterPath}`;
    },
    getBackendRouteFilePath (routeFilename) {
        return `${this.routesPath}${routeFilename}`;
    },
    getBootPluginFilePath (pluginFilename) {
        return `${this.bootPluginsPath}${pluginFilename}`;
    },
    getModelSchemaFilePath (modelId, namespace) {
        return `${modelsFolderPath}${[
            ...namespace,
            modelId
        ].join("/")}/schema.gadget.ts`;
    }
};
const aacPathPreferences = {
    backendFolder: "",
    frontendFolder: "frontend/",
    shopifyExtensionsFolder: "extensions/",
    frontendRoutesFolder: "frontend/routes/",
    modelsFolderPath: "",
    globalActionsFolderPath: "globalActions/",
    routesPath: `routes/`,
    bootPluginsPath: `boot/`,
    computedViewsPath: `views/`,
    backendRouteFileRegex: /^\/?routes\/((\/|[^[:*]*)\/)?GET(-?([^:[*]*)(\..+)?)?\.(js|ts)$/,
    getReactRouterTypeImportStatement: (routeFilePath)=>{
        const routeFilename = routeFilePath.split("/").pop()?.replace(/\.[^.]+$/, "");
        return `import type { Route } from "./+types/${routeFilename}";`;
    },
    getActionFilePath: (modelId, actionId, typescript)=>{
        return `${modelId}/actions/${actionId}.${typescript ? "ts" : "js"}`;
    },
    getActionFolderPath: (props)=>{
        const { namespacedModelApiId } = props;
        return `${namespacedModelApiId}/actions/`;
    },
    getModelFilterFolder: (props)=>{
        const { filterPath } = props;
        return `accessControl/filters/${filterPath}`;
    },
    getBackendRouteFilePath (routeFilename) {
        return `${this.routesPath}${routeFilename}`;
    },
    getBootPluginFilePath (pluginFilename) {
        return `${this.bootPluginsPath}${pluginFilename}`;
    },
    getModelSchemaFilePath (modelId, _namespace) {
        return `${modelsFolderPath}${modelId}/schema.gadget.ts`;
    }
};
const getPathPreferences = (flags)=>{
    return flags.fileBasedActions ? version1PathPreferences : aacPathPreferences;
};
const supportedViteConfigPaths = [
    "vite.config.js",
    "vite.config.ts",
    "vite.config.mjs",
    "vite.config.mts",
    "frontend/vite.config.js",
    "web/vite.config.js"
];
const maybeFindViteConfigFilename = async (finder)=>{
    for (const viteConfigPath of supportedViteConfigPaths){
        if (await finder(viteConfigPath)) {
            return viteConfigPath;
        }
    }
};
const isLegacyViteConfigLocation = (viteConfigPath)=>{
    return viteConfigPath === "web/vite.config.js" || viteConfigPath === "frontend/vite.config.js";
};
const UNKNOWN_SHOPIFY_APP_URL = "https://not-known-at-build-time.gadget.app";
const getFrontendEnvVariables = (platformVariables, userVariables, flags)=>{
    const publicEnvVariables = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.pickBy)(userVariables, (_value, key)=>{
        return key.toLowerCase().startsWith("gadget_public");
    });
    return {
        ...publicEnvVariables,
        GADGET_APP: platformVariables.appSlug,
        GADGET_ENV: platformVariables.environmentSlug,
        GADGET_PUBLIC_APP_SLUG: platformVariables.appSlug,
        GADGET_ENV_ID: platformVariables.environmentId,
        GADGET_PUBLIC_APP_ENV: platformVariables.environmentSlug,
        GADGET_PUBLIC_SHOPIFY_APP_URL: platformVariables.shopifyAppUrl,
        GADGET_APP_TEMPLATE_TYPE: platformVariables.appTemplateType,
        ...flags?.assistantEnabled ? {
            GADGET_FLAG_ASSISTANT_ENABLED: "true"
        } : {}
    };
};
/**
 * Where a log message originates from -- Gadget's platform code, or a user's code like an action or route
 */ var LogSource = /*#__PURE__*/ function(LogSource) {
    LogSource["Platform"] = "platform";
    LogSource["User"] = "user";
    LogSource["Command"] = "command";
    return LogSource;
}({});
const FrameworkPackageName = "gadget-server";
const appBridgeCDNUrl = "https://cdn.shopify.com/shopifycloud/app-bridge.js";
const mockAppBridgeParam = "gadgetmockappbridge";


/***/ }),

/***/ 27202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ DropdownMenu)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui_menu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80500);
/* harmony import */ var baseui_menu__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60433);
/* harmony import */ var baseui_popover__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20463);
/* harmony import */ var baseui_popover__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65911);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _icons_AccordionExpandIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29837);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72919);
/* harmony import */ var _button_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36129);







const ContextMenuListItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_menu__WEBPACK_IMPORTED_MODULE_2__/* .StyledListItem */ .HF, {
        ref: ref,
        ...props,
        $style: {
            ...props.item.header && {
                cursor: "default"
            },
            ...props.item.divider ? {
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderTop */ .om)({
                    borderColor: $theme.colors.borderOpaque,
                    borderStyle: "solid",
                    borderWidth: "1px"
                }),
                transform: `translateY(${$theme.sizing.scale200})`,
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .paddingVertical */ .kx)($theme.sizing.scale200),
                height: 0,
                pointerEvents: "none"
            } : {
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .paddingHorizontal */ .iz)($theme.sizing.scale300),
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .paddingVertical */ .kx)($theme.sizing.scale200),
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .marginHorizontal */ .Lo)($theme.sizing.scale200),
                borderRadius: $theme.sizing.scale200
            }
        },
        "aria-label": props.item.ariaLabel ?? props["aria-label"]
    });
});
const DropdownMenu = (props)=>{
    const [menuOpen, setMenuOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_popover__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, {
        onOpen: ()=>setMenuOpen(true),
        onClose: ()=>setMenuOpen(false),
        placement: props.placement ?? baseui_popover__WEBPACK_IMPORTED_MODULE_5__/* .PLACEMENT */ .El.bottomRight,
        popoverMargin: 0,
        content: ({ close })=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_menu__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, {
                overrides: {
                    List: {
                        style: {
                            width: "140px",
                            overflow: "auto",
                            boxShadow: "none",
                            boxSizing: "content-box",
                            paddingTop: $theme.sizing.scale200,
                            paddingBottom: $theme.sizing.scale200
                        }
                    },
                    Option: {
                        props: {
                            overrides: {
                                ListItem: {
                                    component: ContextMenuListItem
                                }
                            }
                        }
                    },
                    ...props.overrides?.menu
                },
                items: props.items,
                onItemSelect: ({ item })=>{
                    close();
                    item.onSelect();
                }
            }),
        overrides: {
            Body: {
                style: {
                    ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .marginVertical */ .Pv)($theme.sizing.scale200)
                }
            }
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_button_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .$n, {
        kind: "tertiary",
        endEnhancer: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icons_AccordionExpandIcon__WEBPACK_IMPORTED_MODULE_8__/* .AccordionExpandIcon */ .e, {
            direction: props.overrideArrowDirection ?? (menuOpen ? "up" : "down"),
            $style: {
                color: $theme.colors.primary600
            }
        }),
        disabled: false,
        overrides: {
            BaseButton: {
                style: ({ $theme })=>({
                        paddingTop: $theme.sizing.scale200,
                        paddingBottom: $theme.sizing.scale200,
                        paddingLeft: $theme.sizing.scale500,
                        paddingRight: $theme.sizing.scale500,
                        textDecoration: "none",
                        overflow: "hidden",
                        ...menuOpen ? {
                            boxShadow: $theme.lighting.shadowButtonInset,
                            backgroundColor: $theme.colors.alpha50
                        } : undefined,
                        [_button_Button__WEBPACK_IMPORTED_MODULE_7__/* .ButtonHoverSelector */ .E3]: {
                            backgroundColor: $theme.colors.alpha50,
                            textDecoration: "none",
                            boxShadow: menuOpen ? $theme.lighting.shadowButtonInset : undefined
                        },
                        [":active:not(:disabled)"]: {
                            textDecoration: "none",
                            backgroundColor: $theme.colors.alpha100,
                            boxShadow: $theme.lighting.shadowButtonInset,
                            transform: "none"
                        },
                        ...props.overrides?.triggerButton
                    })
            }
        }
    }, props.children));
};


/***/ }),

/***/ 96464:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Fx: () => (/* binding */ ShimmeringText),
/* harmony export */   Gf: () => (/* binding */ EllipsisSpin),
/* harmony export */   I7: () => (/* binding */ SmallSpin),
/* harmony export */   YW: () => (/* binding */ MediumSpin),
/* harmony export */   tK: () => (/* binding */ Spin)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89944);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8928);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60307);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



const Spin = ()=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_spinner__WEBPACK_IMPORTED_MODULE_1__/* .StyledSpinnerNext */ .Mg, {
        $size: baseui_spinner__WEBPACK_IMPORTED_MODULE_2__/* .SIZE */ .S.large
    });
const MediumSpin = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_spinner__WEBPACK_IMPORTED_MODULE_1__/* .StyledSpinnerNext */ .Mg, {
        $style: {
            width: "20px",
            height: "20px",
            ...props.$style
        },
        $size: baseui_spinner__WEBPACK_IMPORTED_MODULE_2__/* .SIZE */ .S.medium
    });
const SmallSpin = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_spinner__WEBPACK_IMPORTED_MODULE_1__/* .StyledSpinnerNext */ .Mg, {
        $style: {
            width: "14px",
            height: "14px",
            ...props.$style
        },
        $size: baseui_spinner__WEBPACK_IMPORTED_MODULE_2__/* .SIZE */ .S.small
    });
const DotCount = 3;
const SpinTime = 1800;
const EllipsisSpin = ()=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .c6)();
    const [dotCount, setDotCount] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const interval = setInterval(()=>{
            setDotCount((prevCount)=>(prevCount + 1) % DotCount);
        }, SpinTime / DotCount);
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        className: "ellipsis-spin " + css({
            display: "inline-block",
            width: "20px"
        })
    }, ".".repeat(dotCount));
};
const ShimmeringText = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        ...props,
        className: css({
            display: "inline-block",
            background: `linear-gradient(
          90deg,
          ${$theme.colors.alpha400} 0%,
          ${$theme.colors.primary} 50%,
          ${$theme.colors.alpha400} 100%
        )`,
            backgroundSize: "200% 100%",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            animation: `shimmer ${SpinTime * 2}ms infinite linear`,
            "@keyframes shimmer": {
                "0%": {
                    backgroundPosition: "200% 0"
                },
                "100%": {
                    backgroundPosition: "-200% 0"
                }
            },
            ...props.$style
        })
    });
};


/***/ }),

/***/ 68689:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ Link),
/* harmony export */   p: () => (/* binding */ isInternalURL)
/* harmony export */ });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12495);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64234);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81724);
/* harmony import */ var _icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22228);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36129);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83712);





const base = typeof window !== "undefined" ? new URL(`${window.location.protocol}//${window.location.host}`) : new URL("https://app.gadget.dev");
function isInternalURL(url) {
    try {
        return new URL(url, base).hostname === base.hostname;
    } catch (error) {
        return true;
    }
}
const Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((props, ref)=>{
    const internal = props.external ? false : isInternalURL(props.href);
    const overrides = lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        BaseButton: {
            style: ({ $theme })=>{
                return {
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    paddingTop: props.compact ? "0px" : undefined,
                    paddingBottom: props.compact ? "0px" : undefined,
                    fontSize: "inherit",
                    fontWeight: "inherit",
                    fontFamily: "inherit",
                    whiteSpace: "no-wrap",
                    color: "inherit",
                    textDecoration: "underline",
                    ":hover:not(:disabled)": {
                        color: "inherit"
                    },
                    ":hover:not(:disabled):not(:active)": {
                        color: "inherit"
                    },
                    ":focus-visible": {
                        color: "inherit",
                        outlineOffset: "3px"
                    },
                    ":disabled": {
                        color: $theme.colors.alpha400,
                        backgroundColor: "transparent"
                    },
                    ":active:not(:disabled)": {
                        color: "inherit",
                        // This is a hack to disable the button's default transform because we set the button as <a/> and it doesn't have the "disabled" HTML attribute
                        transform: props.disabled ? "" : "perspective(500px) translate3d(0, 0, -20px)"
                    }
                };
            }
        },
        EndEnhancer: {
            style: {
                marginLeft: "4px"
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .$n, {
        ref: ref,
        kind: _Button__WEBPACK_IMPORTED_MODULE_3__/* .ButtonKind */ .ZN.tertiary,
        $as: "a",
        target: internal ? undefined : "_blank",
        endEnhancer: props.endEnhancer ?? internal ? null : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_icons_ExternalLinkIcon__WEBPACK_IMPORTED_MODULE_4__/* .ExternalLinkIcon */ .p, {
            $size: props.size == _Button__WEBPACK_IMPORTED_MODULE_5__/* .SIZE */ .SK.compact ? 12 : 16
        }),
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_1___default()(props, [
            "compact"
        ]),
        overrides: overrides
    });
});


/***/ }),

/***/ 62783:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   aF: () => (/* binding */ Modal),
/* harmony export */   cw: () => (/* binding */ ModalBody),
/* harmony export */   rQ: () => (/* binding */ ModalHeader)
/* harmony export */ });
/* unused harmony exports ModalFooter, CloseButton */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78803);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65872);
/* harmony import */ var baseui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16581);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30211);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72919);
/* harmony import */ var _button_PlainButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93189);







const ModalHeader = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalHeader */ .rQ, {
        $as: "header",
        ...props,
        $style: {
            ...$theme.typography.subHeading,
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .RJ)($theme.sizing.scale600),
            ...props.$style
        }
    });
};
const ModalBody = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalBody */ .cw, {
        $as: "section",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .RJ)($theme.sizing.scale600),
            color: $theme.colors.contentPrimary,
            ...props.$style
        }
    });
};
const ModalFooter = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_2__/* .ModalFooter */ .jl, {
        $as: "footer",
        ...props,
        $style: {
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandMargin */ .RJ)($theme.sizing.scale600),
            ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .paddingVertical */ .kx)(0),
            display: "flex",
            gap: $theme.sizing.scale500,
            justifyContent: "end",
            alignItems: "center",
            ...props.$style
        }
    });
};
const Modal = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    const overrides = (0,baseui__WEBPACK_IMPORTED_MODULE_4__/* .mergeOverrides */ .Qp)({
        Close: {
            component: CloseButton,
            props: {
                "data-testid": props["data-testid"] ? `${props["data-testid"]}-close-button` : undefined
            },
            style: {
                position: "absolute",
                top: $theme.sizing.scale600,
                right: $theme.sizing.scale600
            }
        },
        Dialog: {
            props: {
                "data-testid": props["data-testid"]
            },
            style: {
                ...(0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderRadii */ .iw)("8px"),
                boxShadow: $theme.lighting.depth4
            }
        }
    }, props.overrides);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A, {
        unstable_ModalBackdropScroll: true,
        ...props,
        overrides: overrides
    }, props.raw ? props.children : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalHeader, {
        $style: overrides.ModalHeader?.style
    }, props.title), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalBody, {
        $style: overrides.ModalBody?.style
    }, props.children), (props.footer || props.footerLeft) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalFooter, null, props.footerLeft && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            marginRight: "auto"
        })
    }, props.footerLeft), props.footer)));
};
const CloseButton = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_button_PlainButton__WEBPACK_IMPORTED_MODULE_6__/* .PlainButton */ .p, {
        type: "button",
        ...props,
        $style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            ...props.$style
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_7__/* .CloseIcon */ .U, null));


/***/ }),

/***/ 29837:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ AccordionExpandIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89944);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50182);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64234);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81724);




const AccordionExpandIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .c6)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .B, {
        viewBox: "0 0 30 30",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, [
            "direction",
            "$style"
        ]),
        $style: {
            transformOrigin: "center",
            transform: `rotate(${rotation}deg)`,
            ...props.$style
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M20.625 15.0001C20.625 15.1974 20.5494 15.3948 20.3991 15.5451L12.6908 23.2534C12.4704 23.4738 12.1389 23.5401 11.8506 23.4207C11.5623 23.3019 11.375 23.0198 11.375 22.7084V7.29179C11.375 6.98037 11.5623 6.69825 11.8506 6.57954C12.1389 6.46006 12.4704 6.52635 12.6908 6.74681L20.3991 14.4551C20.5494 14.6054 20.625 14.8028 20.625 15.0001Z",
        fill: "currentColor"
    }));
};


/***/ }),

/***/ 87823:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: () => (/* binding */ CircleCheckIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



const CircleCheckIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .B, {
        viewBox: "0 0 12 12",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "6",
        cy: "6",
        r: "6",
        fill: props.backgroundColor ?? "white"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6 1.83333C8.2975 1.83333 10.1667 3.7025 10.1667 6C10.1667 8.2975 8.2975 10.1667 6 10.1667C3.7025 10.1667 1.83333 8.2975 1.83333 6C1.83333 3.7025 3.7025 1.83333 6 1.83333ZM6 1C3.23875 1 1 3.23875 1 6C1 8.76125 3.23875 11 6 11C8.76125 11 11 8.76125 11 6C11 3.23875 8.76125 1 6 1ZM7.83042 4.125L5.47917 6.535L4.3775 5.49083L3.60417 6.265L5.47917 8.08333L8.60417 4.89875L7.83042 4.125Z",
        fill: props.color ?? $theme.colors.positive
    }));
};


/***/ }),

/***/ 30211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);


const CloseIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .B, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z",
        fill: props.color ?? "currentColor"
    }));


/***/ }),

/***/ 22228:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ ExternalLinkIcon)
/* harmony export */ });
/* unused harmony export ExternalLinkIconBox */
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);


// Arrow pointing through the top right corner of a square outline
const ExternalLinkIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .B, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z"
    }));
// Solid colored box with an internal arrow pointing to top right corner
const ExternalLinkIconBox = (props)=>/*#__PURE__*/ React.createElement(StyledSvg, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.1667 2H3.83333C2.82233 2 2 2.82267 2 3.83333V12.1667C2 13.1773 2.82233 14 3.83333 14H12.1667C13.1777 14 14 13.1773 14 12.1667V3.83333C14 2.82267 13.1777 2 12.1667 2ZM12 8.16667C12 8.44267 11.7763 8.66667 11.5 8.66667C11.2237 8.66667 11 8.44267 11 8.16667V5.707L5.85367 10.8537C5.756 10.9513 5.628 11 5.5 11C5.372 11 5.244 10.9513 5.14633 10.8537C4.951 10.6583 4.951 10.342 5.14633 10.1467L10.293 5H7.83333C7.557 5 7.33333 4.776 7.33333 4.5C7.33333 4.224 7.557 4 7.83333 4H11.5C11.7763 4 12 4.224 12 4.5V8.16667Z"
    })));


/***/ }),

/***/ 28524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  V: () => (/* binding */ GadgetLogoMark),
  w: () => (/* binding */ GadgetLogoType)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
;// ../@gadgetinc/widgets/assets/logomark.svg
/* harmony default export */ const logomark = (__webpack_require__.p + "1b5b906861f70ec70ea51c35c1e023be.svg");
;// ../@gadgetinc/widgets/assets/logotype.svg
/* harmony default export */ const logotype = (__webpack_require__.p + "13513703c5b41ce947547e20671b9409.svg");
;// ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx



const GadgetLogoType = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logotype
    });
};
const GadgetLogoMark = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logomark
    });
};


/***/ }),

/***/ 71919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ WarningIcon),
/* harmony export */   s: () => (/* binding */ WarningOutlineIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50182);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



const WarningIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .B, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        x: "7",
        y: "5",
        width: "2",
        height: "8",
        fill: "transparent"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M7.99998 1.59998C7.55648 1.59998 7.17655 1.87023 7.01561 2.25518L1.22707 12.2385V12.2396C1.1226 12.4078 1.06705 12.6019 1.06665 12.8C1.06665 13.0829 1.17903 13.3542 1.37907 13.5542C1.57911 13.7543 1.85042 13.8666 2.13332 13.8666C2.15835 13.8665 2.18336 13.8654 2.20832 13.8635L2.2104 13.8666H7.99998H13.7896L13.7917 13.8625C13.8166 13.8647 13.8416 13.8661 13.8667 13.8666C14.1495 13.8666 14.4209 13.7543 14.6209 13.5542C14.8209 13.3542 14.9333 13.0829 14.9333 12.8C14.9331 12.6015 14.8776 12.4071 14.7729 12.2385L14.7646 12.2239C14.7642 12.2236 14.7639 12.2232 14.7635 12.2229L8.98436 2.25518C8.82342 1.87023 8.44349 1.59998 7.99998 1.59998ZM7.35311 6.05831H8.64686L8.53957 9.51039H7.4604L7.35311 6.05831ZM8.00207 10.5656C8.44047 10.5656 8.70311 10.8015 8.70311 11.2041C8.70311 11.5993 8.44047 11.8343 8.00207 11.8343C7.56047 11.8343 7.29582 11.5993 7.29582 11.2041C7.29582 10.8015 7.55993 10.5656 8.00207 10.5656Z",
        fill: props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : $theme.colors.yellow500)
    }));
};
const WarningOutlineIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .B, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6.99907 1.47461C6.54569 1.47461 6.0923 1.69569 5.84721 2.13827L1.33208 10.2952C0.855896 11.1556 1.50059 12.2509 2.48393 12.2509H11.5148C12.4981 12.2509 13.1428 11.1556 12.6666 10.2952L8.15092 2.13827C7.90584 1.69569 7.45245 1.47461 6.99907 1.47461ZM6.99907 2.31942C7.14739 2.31942 7.29556 2.40004 7.3853 2.56209L11.901 10.7191C12.0741 11.0318 11.8714 11.3759 11.5148 11.3759H2.48393C2.12735 11.3759 1.92463 11.0318 2.0977 10.7191L6.61284 2.56209C6.70258 2.40004 6.85074 2.31942 6.99907 2.31942ZM6.99223 4.6613C6.8763 4.66311 6.76583 4.71086 6.68508 4.79407C6.60433 4.87727 6.55991 4.98913 6.56157 5.10506V8.02173C6.56075 8.0797 6.57146 8.13726 6.59308 8.19106C6.6147 8.24486 6.64679 8.29382 6.6875 8.33511C6.72821 8.3764 6.77671 8.40918 6.8302 8.43156C6.88369 8.45394 6.94109 8.46546 6.99907 8.46546C7.05705 8.46546 7.11445 8.45394 7.16794 8.43156C7.22143 8.40918 7.26993 8.3764 7.31064 8.33511C7.35135 8.29382 7.38344 8.24486 7.40506 8.19106C7.42668 8.13726 7.43739 8.0797 7.43657 8.02173V5.10506C7.43741 5.04651 7.42649 4.98838 7.40445 4.93412C7.38241 4.87986 7.3497 4.83058 7.30826 4.7892C7.26683 4.74781 7.2175 4.71517 7.16322 4.6932C7.10893 4.67123 7.05079 4.66038 6.99223 4.6613ZM6.99907 9.33423C6.84436 9.33423 6.69599 9.39569 6.58659 9.50508C6.47719 9.61448 6.41574 9.76285 6.41574 9.91756C6.41574 10.0723 6.47719 10.2206 6.58659 10.33C6.69599 10.4394 6.84436 10.5009 6.99907 10.5009C7.15378 10.5009 7.30215 10.4394 7.41155 10.33C7.52094 10.2206 7.5824 10.0723 7.5824 9.91756C7.5824 9.76285 7.52094 9.61448 7.41155 9.50508C7.30215 9.39569 7.15378 9.33423 6.99907 9.33423Z",
        fill: "currentColor"
    }));
};


/***/ }),

/***/ 36205:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ MonoBody),
/* harmony export */   n: () => (/* binding */ Body)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const Body = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("p", ({ $theme })=>({
        ...$theme.typography.body,
        color: $theme.colors.contentPrimary
    }));
const MonoBody = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("p", ({ $theme })=>({
        ...$theme.typography.MonoLabelMedium,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 4516:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ PageTitle)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const PageTitle = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("h1", ({ $theme })=>({
        ...$theme.typography.title,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 17028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ DataType)
/* harmony export */ });
/** Enum for display-friendly data type names */ var DataType = /*#__PURE__*/ function(DataType) {
    DataType["Precondition"] = "Precondition";
    DataType["Connection"] = "Connection";
    DataType["Effect"] = "Effect";
    DataType["Validation"] = "Validation";
    DataType["ValidationConfiguration"] = "ValidationConfiguration";
    DataType["Action"] = "Action";
    DataType["ActionSection"] = "Action Section";
    DataType["GlobalAction"] = "Global Action";
    DataType["State"] = "State";
    DataType["Transition"] = "Transition";
    DataType["ModelField"] = "Field";
    DataType["DataModel"] = "Model";
    DataType["SourceFile"] = "File";
    return DataType;
}({});


/***/ }),

/***/ 81957:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IU: () => (/* binding */ MainPromptVersion),
/* harmony export */   MO: () => (/* binding */ AssistantSpecialMessages),
/* harmony export */   uR: () => (/* binding */ MAX_USER_MESSAGE_LENGTH)
/* harmony export */ });
/* unused harmony exports NextPromptVersion, PromptVersions */
const MainPromptVersion = "main";
const NextPromptVersion = "next";
const MAX_USER_MESSAGE_LENGTH = 10000;
const PromptVersions = [
    MainPromptVersion,
    NextPromptVersion
];
var AssistantSpecialMessages = /*#__PURE__*/ function(AssistantSpecialMessages) {
    AssistantSpecialMessages["generateSampleTestData"] = "!generateSampleTestData";
    AssistantSpecialMessages["makeKitchenSink"] = "!makeKitchenSink";
    AssistantSpecialMessages["sayHello"] = "!sayHello";
    AssistantSpecialMessages["bigHello"] = "!bigHello";
    AssistantSpecialMessages["describeScreenshots"] = "!describeScreenshots";
    AssistantSpecialMessages["addTodoModel"] = "!addTodoModel";
    AssistantSpecialMessages["addApiKey"] = "!addApiKey";
    AssistantSpecialMessages["addProductShopifyConnection"] = "!addProductShopifyConnection";
    AssistantSpecialMessages["addOrderShopifyConnection"] = "!addOrderShopifyConnection";
    AssistantSpecialMessages["partnerConnect"] = "!partnerConnect";
    AssistantSpecialMessages["updateGoogleOAuthCredentials"] = "!updateGoogleOAuthCredentials";
    AssistantSpecialMessages["sleep"] = "!sleep";
    AssistantSpecialMessages["createOrUpdateFile"] = "!createOrUpdateFile";
    return AssistantSpecialMessages;
}({});


/***/ }),

/***/ 9420:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BF: () => (/* binding */ toSlug),
/* harmony export */   X2: () => (/* binding */ slugnderscore),
/* harmony export */   Xw: () => (/* binding */ defaultSlugForUser),
/* harmony export */   rV: () => (/* binding */ maybePluralize),
/* harmony export */   yZ: () => (/* binding */ joinWords)
/* harmony export */ });
/* unused harmony export slugToName */
/* harmony import */ var superflected__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76998);

const slugnderscore = (str)=>(0,superflected__WEBPACK_IMPORTED_MODULE_0__/* .parameterize */ .y9)(str, {
        separator: "_"
    }).replace(/[^a-zA-Z0-9_]/g, "_");
const toSlug = (name)=>(0,superflected__WEBPACK_IMPORTED_MODULE_0__/* .dasherize */ ._k)(slugnderscore(name));
const slugToName = (slug)=>slug.replace(/-/g, " ").replace(/_/g, " ").split(" ").map(titleize).join(" ");
const maybePluralize = (word, options)=>options.count == 1 ? word : (0,superflected__WEBPACK_IMPORTED_MODULE_0__/* .pluralize */ .td)(word, options.locale);
/** Joins an array of words using grammatically correct punctuation and words ("and") */ const joinWords = (words)=>{
    if (words.length === 0) return "";
    const localWords = [
        ...words
    ];
    const last = localWords.pop();
    const length = localWords.length;
    return length === 0 ? last : `${localWords.join(", ")}${length > 1 ? "," : ""} and ${last}`;
};
const defaultSlugForUser = (user, existingSlugs = [])=>{
    const name = user.name ?? user.email.split("@")[0];
    const slugName = toSlug(name);
    const slugSegments = slugName.split("-");
    let slug;
    if (slugSegments[0].length > 3) {
        slug = slugSegments[0];
    } else {
        slug = slugName;
    }
    let slugSuffix = 2;
    let slugCandidate = `${slug}-dev`;
    while(existingSlugs.includes(slugCandidate)){
        slugCandidate = `${slug}-dev-${slugSuffix}`;
        slugSuffix++;
    }
    return slugCandidate;
};


/***/ }),

/***/ 73895:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $I: () => (/* binding */ getClientPackageName),
/* harmony export */   $m: () => (/* binding */ defaultLogqlQuery),
/* harmony export */   AM: () => (/* binding */ defaultNowDateType),
/* harmony export */   AP: () => (/* binding */ countDecimals),
/* harmony export */   Ae: () => (/* binding */ contentHash),
/* harmony export */   BL: () => (/* binding */ isLiveRoot),
/* harmony export */   Ch: () => (/* binding */ GadgetModelClass),
/* harmony export */   FI: () => (/* binding */ maybeGetParentOfTypeThroughGeneratingParent),
/* harmony export */   Hh: () => (/* binding */ deserializeObjectFromHTTPQuery),
/* harmony export */   KR: () => (/* binding */ gadgetModelType),
/* harmony export */   Li: () => (/* binding */ mapToObject),
/* harmony export */   M8: () => (/* binding */ defineGeneratingParentVolatile),
/* harmony export */   OG: () => (/* binding */ maybeYield),
/* harmony export */   QL: () => (/* binding */ deterministicFieldStorageEpochKey),
/* harmony export */   Qw: () => (/* binding */ stringBucketHash),
/* harmony export */   RI: () => (/* binding */ safelyParseJsonString),
/* harmony export */   S1: () => (/* binding */ convertCurrencyToBaseUnits),
/* harmony export */   S7: () => (/* binding */ getGadgetEnv),
/* harmony export */   T2: () => (/* binding */ prettyJSON),
/* harmony export */   Tm: () => (/* binding */ GeneratingParentClass),
/* harmony export */   Uj: () => (/* binding */ setMapKeysToValues),
/* harmony export */   VC: () => (/* binding */ getNamespacedApiIdentifier),
/* harmony export */   VF: () => (/* binding */ isFieldStorageEpochKeyDeterministic),
/* harmony export */   X7: () => (/* binding */ serializeObjectToHTTPQuery),
/* harmony export */   XY: () => (/* binding */ numberOfDecimalsForCurrency),
/* harmony export */   Y8: () => (/* binding */ validationModelKey),
/* harmony export */   ZZ: () => (/* binding */ getGeneratingRoot),
/* harmony export */   a3: () => (/* binding */ getMountedHTTPPathFromBackendRouteFilePath),
/* harmony export */   ao: () => (/* binding */ getDataTypeDisplayName),
/* harmony export */   bm: () => (/* binding */ convertCurrencyToSubUnits),
/* harmony export */   cH: () => (/* binding */ changeFilenameInPath),
/* harmony export */   d6: () => (/* binding */ ggtDevCommand),
/* harmony export */   e_: () => (/* binding */ getAllParentsThroughGeneratingRoot),
/* harmony export */   et: () => (/* binding */ getEnvWithGeneratingParent),
/* harmony export */   f8: () => (/* binding */ getParentOfTypeThroughGeneratingParent),
/* harmony export */   gJ: () => (/* binding */ errorMessage),
/* harmony export */   gS: () => (/* binding */ actionSortIterators),
/* harmony export */   iP: () => (/* binding */ unthunk),
/* harmony export */   j: () => (/* binding */ validateColorString),
/* harmony export */   k2: () => (/* binding */ getCodeScriptExtension),
/* harmony export */   kx: () => (/* binding */ fieldTypeName),
/* harmony export */   lr: () => (/* binding */ firstAncestorImplementing),
/* harmony export */   m3: () => (/* binding */ fieldSortIterators),
/* harmony export */   mW: () => (/* binding */ stableSnapshotJSON),
/* harmony export */   n6: () => (/* binding */ debugActions),
/* harmony export */   od: () => (/* binding */ getFrameworkFeaturesMap),
/* harmony export */   pt: () => (/* binding */ caseInsensitiveAlphabeticalSorter),
/* harmony export */   rh: () => (/* binding */ generateKey),
/* harmony export */   su: () => (/* binding */ GadgetDomainModelClass),
/* harmony export */   tK: () => (/* binding */ gadgetModelKey),
/* harmony export */   tZ: () => (/* binding */ getLogger),
/* harmony export */   tl: () => (/* binding */ getAppSettings),
/* harmony export */   to: () => (/* binding */ nodeTypeType),
/* harmony export */   uM: () => (/* binding */ separateNamespacedApiIdentifier),
/* harmony export */   vA: () => (/* binding */ assert),
/* harmony export */   vc: () => (/* binding */ getEnvironmentSlug),
/* harmony export */   wQ: () => (/* binding */ getParentOfNodeType),
/* harmony export */   x0: () => (/* binding */ isTreeTestRoot),
/* harmony export */   xq: () => (/* binding */ cyrb53),
/* harmony export */   yG: () => (/* binding */ maybeGetParentOfType),
/* harmony export */   yb: () => (/* binding */ validateNumber),
/* harmony export */   yy: () => (/* binding */ sleep)
/* harmony export */ });
/* unused harmony exports weakMapMemoize, never, keyType, niceTypeName, isNodeOfType, getAncestors, isAncestor, maybeGetParentOfNodeType, moveMSTArrayElement, exactDateForIsoTimestampInTimezone, stripModelKeyPrefix, gadgetDomainModelType, nodeContainerModel, getClientPackageScope, runOnceInObserver, HARDCODED_FIELD_ORDER, HARDCODED_ACTION_ORDER, HARDCODED_USER_ACTION_ORDER, HARDCODED_USER_ACTION_REVERSED_ORDER, HARDCODED_ACTION_REVERSED_ORDER, MAX_FUTURE_TIMESTAMP, dateSortIterator, fieldSortOrderForApiIdentifier, actionIterator, fieldIterator, validationSortIterators, unbrand, DisableCloseAccountTeamIds, logsSearchFieldBlocklist */
/* harmony import */ var _gadgetinc_conventions__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26841);
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56982);
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var json5__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94256);
/* harmony import */ var json5__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(json5__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39960);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_clamp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3794);
/* harmony import */ var lodash_compact__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5863);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isBoolean__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27621);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isError__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isFunction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27787);
/* harmony import */ var lodash_isFunction__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7168);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isNull__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47314);
/* harmony import */ var lodash_isNull__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isNull__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97022);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42895);
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_isUndefined__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75179);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_last__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68487);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_memoize__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40810);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(88041);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71358);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var safe_stable_stringify__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75095);
/* harmony import */ var superflected__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(76998);
/* harmony import */ var _DataType__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(17028);
/* harmony import */ var _stringUtils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(9420);
/* harmony import */ var _type_system_FieldType__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(21687);
/* harmony import */ var _versioning_FrameworkVersions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(98706);
/* eslint-disable @typescript-eslint/no-empty-object-type */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports
























function assert(value, message) {
    if (!value) {
        throw new Error("assertion error" + (message ? `: ${message}` : ""));
    }
    return value;
}
const unthunk = (value, ...args)=>{
    if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_6___default()(value)) {
        return value(...args);
    } else {
        return value;
    }
};
const weakMapMemoize = (func, resolver)=>{
    const memoized = memoize(func, resolver);
    memoized.cache = new WeakMap();
    return memoized;
};
const never = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.frozen();
const generateKey = ()=>(0,nanoid__WEBPACK_IMPORTED_MODULE_21__/* .nanoid */ .Ak)(12);
const keyType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, generateKey);
const niceTypeName = (type)=>type.name;
/** Action definition function for mobx-state-trees that adds handy actions to them in development for debugging */ // eslint-disable-next-line @typescript-eslint/no-empty-object-type
const debugActions = (self)=>{
    return {
        debugAssign (values) {
            for (const [key, value] of Object.entries(values)){
                self[key] = value;
            }
        }
    };
};
/** Boolean checker and TypeScript type guard that checks if a given doodad is an instance of a mobx-state-tree type. It'd be nice to use mobx-state-tree's built in Type.is() for this, but .is() returns true for snapshots as well as instances, this checks explicitly for instances. */ function isNodeOfType(node, type) {
    return isStateTreeNode(node) && type.is(node);
}
const getAncestors = (node)=>{
    const result = [];
    let cursor = node;
    while(!isRoot(cursor)){
        cursor = getParent(cursor);
        result.push(cursor);
    }
    return result;
};
const isAncestor = (node, maybeAncestor)=>{
    let cursor = node;
    while(!isRoot(cursor)){
        cursor = getParent(cursor);
        if (cursor == maybeAncestor) {
            return true;
        }
    }
    return false;
};
const firstAncestorImplementing = (node, func)=>{
    let cursor = node;
    while(!(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.isRoot)(cursor)){
        if (func in cursor) {
            return cursor;
        }
        cursor = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParent)(cursor);
    }
    return null;
};
const maybeGetParentOfType = (node, type)=>{
    try {
        return (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParentOfType)(node, type);
    } catch (e) {
        return null;
    }
};
const getParentOfNodeType = (node, type)=>{
    let cursor = node;
    while(cursor){
        if ("type" in cursor && cursor.type === type) {
            return cursor;
        }
        if ((0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.isRoot)(cursor)) {
            if ("generatingParent" in cursor) {
                cursor = cursor.generatingParent;
            } else {
                break;
            }
        } else {
            cursor = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParent)(cursor);
        }
    }
    throw new Error(`couldn't locate parent of type ${type} for node type ${(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getType)(node).name}`);
};
const maybeGetParentOfNodeType = (node, type)=>{
    try {
        return getParentOfNodeType(node, type);
    } catch (e) {
        return null;
    }
};
/**
 * @deprecated Please use OrderedMaps to store ordered lists of things
 */ const moveMSTArrayElement = (array, from, delta)=>{
    const newItems = array.slice();
    const to = clamp(from + delta, 0, array.length - 1);
    newItems.splice(to, 0, newItems.splice(from, 1)[0]);
    array.replace(newItems);
};
/** A Date type that sets itself to now the first time an instance is created */ const defaultNowDateType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.Date, ()=>luxon__WEBPACK_IMPORTED_MODULE_13__/* .DateTime */ .c9.utc().toJSDate());
const exactDateForIsoTimestampInTimezone = (isoTimestamp, timezone = "UTC")=>{
    return assert(DateTime.fromISO(isoTimestamp, {
        zone: timezone
    }).toISODate(), `Invalid ISO timestamp ${isoTimestamp} in timezone ${timezone}`);
};
/**
 *  Returns a MST type that sticks a string literal in the actual nodes that TypeScript understands, so a Page without any other properties might have a JSON representation of `{"tag": "Page"}`. Useful for understanding what the heck is where and what type it is, as well as for typescript's discriminated unions and switch statements on unions of types that are typesafe automagically (switch node.tag ...)
 */ const nodeTypeType = (type)=>_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.literal(type), type);
const validationModelKey = (fieldKey, validationSpecId, order)=>{
    return `Validation-${fieldKey}-${validationSpecId}-${order}`;
};
const deterministicFieldStorageEpochKey = (fieldType, fieldKey)=>{
    return `${fieldType}-${fieldKey}`;
};
const isFieldStorageEpochKeyDeterministic = (epochKey, field)=>{
    return epochKey === deterministicFieldStorageEpochKey(field.fieldType, field.key);
};
/**
 * Return a unique key for a Gadget MST model with the given name.
 */ const gadgetModelKey = (name)=>{
    return generateKey();
};
/**
 * Return the key of a type without its type prefix.
 */ const stripModelKeyPrefix = (model)=>{
    return model.key.replace(`${model.type}-`, "");
};
/**
 * Gadget specific. Defines a mobx-state-tree model type with a name, a type property, and a key property. Similar to `gadgetDomainModelType`, but should be preferred for transient or framework-y types. Anything that goes in the database should use `gadgetDomainModelType`.
 * Equivalent to calling:
 *
 * ```typescript
 * types.model(name, { type: nodeTypeType(name), key: keyType})
 * ```
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 * @deprecated use Class Models instead
 * @see GadgetModelClass
 */ const gadgetModelType = (name, options)=>_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.model(name, {
        type: nodeTypeType(name),
        key: _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, ()=>gadgetModelKey(name)),
        ...options
    }).actions(debugActions);
/**
 * Defines a mobx-quick-tree base model class model type with a name, a type property, and a key property. Similar to `GadgetDomainModelClass`,  but should be preferred for transient or framework-y types. Anything that goes in the database should use `gadgetDomainModelType`.
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 */ const GadgetModelClass = (name, options)=>(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.ClassModel)({
        type: nodeTypeType(name),
        key: _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, ()=>gadgetModelKey(name)),
        ...options
    });
/**
 * Gadget specific. Defines a mobx-state-tree model type with a name, a type property, a key property, and bookkeeping properties for tracking when the object was created. Similar to `gadgetModelType`, but should be preferred for any non-transient or high value objects that get persisted.
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 *
 * @deprecated use Class Models instead
 * @see GadgetDomainModelClass
 */ const gadgetDomainModelType = (name, options)=>types.model(name, {
        type: nodeTypeType(name),
        key: types.optional(types.identifier, ()=>gadgetModelKey(name)),
        createdDate: defaultNowDateType,
        ...options
    }).actions(debugActions);
/**
 * Defines a mobx-quick-tree base model class model type with a name, a type property, a key property, and bookkeeping properties for tracking when the object was created. Similar to `gadgetModelClass`, but should be preferred for any non-transient or high value objects that get persisted.
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 */ const GadgetDomainModelClass = (name, options)=>(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.ClassModel)({
        type: nodeTypeType(name),
        key: _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, ()=>gadgetModelKey(name)),
        createdDate: defaultNowDateType,
        ...options
    });
/**
 * Returns an MST model type that has a `children` array of the passed type and actions for mutating that.
 * Useful for creating View nodes that hold a bunch of children and need to let the Selection mutate them.
 */ const nodeContainerModel = (name, childType)=>{
    return types.model(name, {
        type: nodeTypeType(name),
        key: types.optional(types.identifier, ()=>gadgetModelKey(name)),
        createdDate: defaultNowDateType,
        children: types.array(childType)
    }).actions(debugActions).actions((self)=>({
            addChild (node) {
                self.children.push(node);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return last(self.children);
            },
            removeChild (node) {
                self.children.remove(node);
            },
            moveChild (node, delta) {
                moveMSTArrayElement(self.children, self.children.indexOf(node), delta);
            }
        }));
};
/**
 * Returns a map of framework features that are supported by the given framework version.
 *
 * The map is intended to act as a human-readable way to check if a feature is supported by a given framework version,
 * so each feature listed in the map should be based on the framework version only, and not on any other factors.
 */ const getFrameworkFeaturesMap = (frameworkVersion)=>{
    return {
        supportNamespace: (0,_versioning_FrameworkVersions__WEBPACK_IMPORTED_MODULE_20__/* .doesVersionSupportNamespace */ .SL)(frameworkVersion),
        supportViteGadgetPlugin: (0,_versioning_FrameworkVersions__WEBPACK_IMPORTED_MODULE_20__/* .doesVersionSupportGadgetVitePlugin */ .U0)(frameworkVersion),
        supportModelFieldsInActionParamsType: (0,_versioning_FrameworkVersions__WEBPACK_IMPORTED_MODULE_20__/* .doesVersionSupportModelFieldsInActionParamsType */ .gu)(frameworkVersion),
        supportHydratedSandboxTypes: (0,_versioning_FrameworkVersions__WEBPACK_IMPORTED_MODULE_20__/* .doesVersionSupportHydratedSandboxTypes */ .ur)(frameworkVersion),
        fastifyVersion: (0,_versioning_FrameworkVersions__WEBPACK_IMPORTED_MODULE_20__/* .getFastifyVersion */ .Vh)(frameworkVersion),
        nodeVersion: (0,_versioning_FrameworkVersions__WEBPACK_IMPORTED_MODULE_20__/* .getNodeVersion */ .tu)(frameworkVersion)
    };
};
const prettyJSON = (value)=>JSON.stringify(value, null, 2);
const getClientPackageScope = (env = "development")=>{
    return env == "production" ? "@gadget-client" : `@gadget-client-${env}`;
};
/**
 * Get the name of the npm package for an application's generated client, like `@gadget-client/my-cool-blog`
 * We use a per-app package name for each client so that external projects can install clients from more than one gadget app
 **/ const getClientPackageName = (platformEnv = "development", slug)=>{
    if (false) {}
    return `${getClientPackageScope(platformEnv)}/${slug}`;
};
const getGadgetEnv = (node)=>{
    const env = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node);
    if (!env.extensionRegistry) {
        throw new Error(`Can't get gadget env for tree node ${String(node)}, current env at the root doesn't have expected Gadget keys`);
    }
    return env;
};
const getLogger = (node)=>{
    const env = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node);
    if (!env.console) {
        throw new Error(`Can't get gadget logger for tree node ${String(node)}, current env at the root doesn't have expected console key`);
    }
    return env.console;
};
/**
 * General purpose fast hashing function that works in the browser and in node.
 * Credit https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
 **/ const cyrb53 = (str, seed = 0)=>{
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(let i = 0, ch; i < str.length; i++){
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
/**
 * Utility to produce a content hash from a list of a model's values which define it's content
 */ const contentHash = Object.assign((values)=>{
    const stringified = values.map((value)=>{
        if (lodash_isNull__WEBPACK_IMPORTED_MODULE_8___default()(value)) return "<<null>>";
        if (lodash_isUndefined__WEBPACK_IMPORTED_MODULE_10___default()(value)) return "<<undefined>>";
        if (lodash_isBoolean__WEBPACK_IMPORTED_MODULE_4___default()(value)) return `<<${String(value)}>>`;
        if (lodash_isNumber__WEBPACK_IMPORTED_MODULE_9___default()(value)) return `##${String(value)}`;
        return value;
    });
    const hash = cyrb53(stringified.join("///"));
    // when we want to diagnose why content hashes don't match, this lets us compare the whole tree of values that went into a hash. it's just slow so we only activate this during the tests
    if (contentHash.includeDebugInfo) {
        contentHash.debugInfos[hash] = values.map((value)=>{
            if (lodash_isNumber__WEBPACK_IMPORTED_MODULE_9___default()(value) && contentHash.debugInfos[value]) {
                return contentHash.debugInfos[value];
            } else {
                return value;
            }
        });
    }
    return hash;
}, {
    debugInfos: {},
    includeDebugInfo: false
});
const validateNumber = (numberAsString, maximumDecimals)=>{
    if (isFinite(Number(numberAsString))) {
        return !lodash_isNil__WEBPACK_IMPORTED_MODULE_7___default()(maximumDecimals) ? countDecimals(Number(numberAsString)) <= maximumDecimals : true;
    }
    return false;
};
const countDecimals = (value)=>{
    if (!isFinite(value)) {
        return 0;
    }
    return value.toString().split(".")[1]?.length || 0;
};
const validateColorString = (colorString)=>/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(colorString);
/**
 * These should be updated to refer to a library that can convert based on the currency when we support more than CAD and USD.
 */ const convertCurrencyToSubUnits = (value)=>{
    if (!isFinite(value)) {
        return 0;
    }
    return Math.round(value * 100); //round to ensure the result is an integer and protect against floating point math errors
};
const convertCurrencyToBaseUnits = (value)=>{
    if (!isFinite(value)) {
        return 0;
    }
    return value / 100.0;
};
const numberOfDecimalsForCurrency = ()=>{
    return 2;
};
/**
 *  Get a JSON stringified snapshot of a model with stable (sorted) key order so the snapshot text is identical regardless of key insertion order
 */ const stableSnapshotJSON = (node)=>(0,safe_stable_stringify__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Ay)((0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getSnapshot)(node));
/**
 * Safely parses a JSON string into an object, returning undefined if parsing fails.
 * @param objectString The JSON string to parse
 * @returns The parsed object or undefined if parsing fails
 */ const safelyParseJsonString = (objectString)=>{
    try {
        return json5__WEBPACK_IMPORTED_MODULE_1___default().parse(objectString);
    } catch (error) {
        return undefined;
    }
};
const mapToObject = (map)=>Object.fromEntries(map.entries());
/**
 * Figure out if a given root MST node is a `LiveRoot`. We have a couple different live roots both client side, server side, and in production vs in the tests, so we use this utility to identify them instead of doing the same type checks everywhere.
 */ const isLiveRoot = (node)=>{
    return node.type == "ClientEnvironmentRoot" || node.type == "LiveRoot";
};
const isTreeTestRoot = (node)=>{
    return node.type == "SimpleTreeTestRoot";
};
/**
 * Get a string representing an error that is an `Error` object or anything else that might be `throw`n
 */ const errorMessage = (error)=>{
    if (typeof error == "string") {
        return error;
    } else if (lodash_isError__WEBPACK_IMPORTED_MODULE_5___default()(error)) {
        return error.message;
    } else {
        return String(error);
    }
};
/**
 * Some of our derived field nodes like `ObjectField`s are often their own MST root. This is because we generate them dynamically and treat them as values that go away most of the time -- they're derived data, ephemeral, and not stuck in the tree as persisted nodes.
 *
 * Because of this, they are disconnected from the greater context that might have generated them. `getRoot(someObjectField)` often returns the object field itself, or a quite close parent of it, and it doesn't get us the `WorkspaceRoot` or `FullServerEnvironmentRoot` or whatever of the whole application which generated it. So, we track the root that really did generate the `ObjectField` in a volatile `generatingParent` property so that our traversal functions can get back to the real root when they need to.
 * @deprecated use model classes
 * @see GeneratingParentClass
 */ const defineGeneratingParentVolatile = ()=>{
    let generatingParent = null;
    return {
        views: {
            get generatingParent () {
                return generatingParent;
            }
        },
        actions: {
            setGeneratingParent (value) {
                generatingParent = value;
            }
        }
    };
};
/**
 * Some of our derived field nodes like `ObjectField`s are often their own MST root. This is because we generate them dynamically and treat them as values that go away most of the time -- they're derived data, ephemeral, and not stuck in the tree as persisted nodes.
 *
 * Because of this, they are disconnected from the greater context that might have generated them. `getRoot(someObjectField)` often returns the object field itself, or a quite close parent of it, and it doesn't get us the `WorkspaceRoot` or `FullServerEnvironmentRoot` or whatever of the whole application which generated it. So, we track the root that really did generate the `ObjectField` on its env's `generatingParent` property so that our traversal functions can get back to the real root when they need to.
 */ const GeneratingParentClass = (Klass)=>{
    class GeneratingParent extends Klass {
        get generatingParent() {
            if ((0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.hasEnv)(this)) {
                return (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(this).generatingParent;
            }
        }
    }
    return GeneratingParent;
};
/**
 * Returns the environment with the `generatingParent` property set to the given node.
 * @param node - The state tree node.
 * @returns The environment object with the `generatingParent` property set to the given node.
 */ const getEnvWithGeneratingParent = (node)=>{
    return {
        ...(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node),
        generatingParent: node
    };
};
/**
 * Returns all the parent nodes for any given node, similar to chained `getParent` calls from the MST API. But, we jump up through any ephemeral roots like `ObjectField` or `FloatingValueField` back to a really useful root like `LiveRoot` or `FullWorkspaceRoot` and keep returning parents.
 *
 * @see defineGeneratingParentVolatile
 */ const getAllParentsThroughGeneratingRoot = (node)=>{
    const parents = [];
    let cursor = node;
    while(cursor){
        if ((0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.isRoot)(cursor)) {
            const newRoot = getGeneratingRoot(cursor);
            if (newRoot != cursor) {
                cursor = newRoot;
            } else {
                break;
            }
        } else {
            cursor = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParent)(cursor);
        }
        parents.push(cursor);
    }
    return parents;
};
const maybeGetParentOfTypeThroughGeneratingParent = (node, type)=>{
    try {
        return getParentOfTypeThroughGeneratingParent(node, type);
    } catch (e) {
        return null;
    }
};
const getParentOfTypeThroughGeneratingParent = (node, type)=>{
    let cursor = node;
    while(cursor){
        if ((0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.isRoot)(cursor)) {
            if (cursor.generatingParent) {
                cursor = cursor.generatingParent;
            } else {
                break;
            }
        } else {
            cursor = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParent)(cursor);
        }
        if (cursor && type.is(cursor)) {
            return cursor;
        }
    }
    throw new Error(`couldn't locate parent of type ${type.name} for node type ${(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getType)(node).name}`);
};
/**
 * Returns the root MST node for any given node, similar to `getRoot` from the MST API. But, we jump up through any ephemeral roots like `ObjectField` or `FloatingValueField` back to a really useful root like `LiveRoot` or `FullWorkspaceRoot`.
 *
 * @see defineGeneratingParentVolatile
 */ const getGeneratingRoot = (node)=>{
    const root = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getRoot)(node);
    // traverse to the root-most root that might have generated this root
    if ("generatingParent" in root && root.generatingParent) {
        return getGeneratingRoot(root.generatingParent);
    }
    return root;
};
/**
 * Returns a promise that when awaited on will sleep for the desired amount of time.
 * @param ms Time in milliseconds to sleep for
 * @returns A promise that will sleep for `ms` seconds.
 */ const sleep = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
/**
 * Run the given function in a mobx observer for the side effect of mobx computeds being cached.
 */ const runOnceInObserver = (func)=>{
    let result = null;
    let error = null;
    const dispose = autorun(()=>{
        try {
            result = func();
        } catch (innerError) {
            error = innerError;
        }
    });
    dispose();
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    if (error) throw error;
    return result;
};
function fieldTypeName(fieldType) {
    switch(fieldType){
        case _type_system_FieldType__WEBPACK_IMPORTED_MODULE_19__/* .FieldType */ .PU.HasManyThrough:
            return "has many through";
        case _type_system_FieldType__WEBPACK_IMPORTED_MODULE_19__/* .FieldType */ .PU.RoleAssignments:
            return "role list";
        case _type_system_FieldType__WEBPACK_IMPORTED_MODULE_19__/* .FieldType */ .PU.DateTime:
            return "date / time";
        default:
            return (0,superflected__WEBPACK_IMPORTED_MODULE_16__/* .underscore */ .z9)(fieldType).replace("_", " ");
    }
}
const HARDCODED_FIELD_ORDER = {
    id: 0,
    createdAt: 1,
    updatedAt: 2,
    state: 3
};
const HARDCODED_ACTION_ORDER = {
    create: 0,
    update: 1,
    delete: 2
};
const HARDCODED_USER_ACTION_ORDER = {
    signUp: 0,
    signIn: 1,
    signOut: 2,
    update: 3,
    delete: 4,
    sendVerifyEmail: 5,
    verifyEmail: 6,
    sendResetPassword: 7,
    resetPassword: 8,
    changePassword: 9
};
const HARDCODED_USER_ACTION_REVERSED_ORDER = {
    signUp: 9,
    signIn: 8,
    signOut: 7,
    update: 6,
    delete: 5,
    sendVerifyEmail: 4,
    verifyEmail: 3,
    sendResetPassword: 2,
    resetPassword: 1,
    changePassword: 0
};
const HARDCODED_ACTION_REVERSED_ORDER = {
    create: 2,
    update: 1,
    delete: 0
};
const MIN_PAST_TIMESTAMP = 31535999000;
const MAX_FUTURE_TIMESTAMP = 90000000000000;
function dateSortIterator(record) {
    if (typeof record.createdDate === "number") {
        // If date is close to epoch zero, use a date far into the future as a fallback
        if (record.createdDate < MIN_PAST_TIMESTAMP) {
            return MAX_FUTURE_TIMESTAMP;
        } else {
            return record.createdDate;
        }
    } else {
        return record.createdDate.getTime();
    }
}
const fieldSortOrderForApiIdentifier = (apiIdentifier)=>{
    return HARDCODED_FIELD_ORDER[apiIdentifier] ?? 1000;
};
/**
 * Lodash-centric sort function, to sort by a `createdDate` date, except in the case of the
 * 4 system values (ID, Created At, Updated At, and State), which are hardcoded to that order.
 */ function actionIterator(record, actionOrderList) {
    const id = record.apiIdentifier;
    if (actionOrderList[id] !== undefined) {
        return actionOrderList[id];
    }
    return dateSortIterator(record);
}
function fieldIterator(record) {
    const id = record.apiIdentifier;
    if (HARDCODED_FIELD_ORDER[id] !== undefined) {
        return HARDCODED_FIELD_ORDER[id];
    }
    return dateSortIterator(record);
}
const actionSortIterators = (action, isUserModel, opts)=>{
    let actionsOrders;
    if (isUserModel) {
        actionsOrders = opts?.descending ? HARDCODED_USER_ACTION_REVERSED_ORDER : HARDCODED_USER_ACTION_ORDER;
    } else {
        actionsOrders = opts?.descending ? HARDCODED_ACTION_REVERSED_ORDER : HARDCODED_ACTION_ORDER;
    }
    return actionIterator(action, actionsOrders);
};
/** Lodash-centric sort iterators to sort by `createdDate` and `key`, respectively */ const fieldSortIterators = [
    fieldIterator,
    "key"
];
const validationSortIterators = [
    dateSortIterator,
    "key"
];
/** Get data type display name */ function getDataTypeDisplayName(type) {
    return String(_DataType__WEBPACK_IMPORTED_MODULE_17__/* .DataType */ .p[type] ?? type);
}
function getMountedHTTPPathFromBackendRouteFilePath(filePath, fileBasedActions = false) {
    const pathPreferences = (0,_gadgetinc_conventions__WEBPACK_IMPORTED_MODULE_22__/* .getPathPreferences */ .sc)({
        fileBasedActions
    });
    const match = filePath.match(pathPreferences.backendRouteFileRegex);
    if (match) {
        const separator = match[4]?.startsWith(".") ? "" : "/";
        return "/" + [
            match[2],
            match[4]
        ].filter((m)=>m).map((m)=>m.replace(/^\/+|\/+$/g, "")).join(separator);
    } else {
        return null;
    }
}
const stringBucketHash = (str, buckets)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Convert to 32-bit integer
    }
    return (hash % buckets + buckets) % buckets; // Ensure the result is within the range [0, 19]
};
/**
 * @deprecated Use `settings.logsParamsForKeyValues` instead.
 */ const defaultLogqlQuery = (environmentId, linePrefilter = "")=>{
    const environmentFilter = environmentId ? `{environment_id="${environmentId}"}` : `{environment_id=~".+"}`;
    return linePrefilter ? `${environmentFilter} |= "${linePrefilter}" | json | level=~"info|warn|error"` : `${environmentFilter} | json | level=~"info|warn|error"`;
};
const serializeObjectToHTTPQuery = (obj)=>{
    const data = qs__WEBPACK_IMPORTED_MODULE_14___default().stringify(obj);
    return data ? `?${data}` : "";
};
const deserializeObjectFromHTTPQuery = (query)=>{
    if (!query) return undefined;
    const params = query.substr(1);
    return qs__WEBPACK_IMPORTED_MODULE_14___default().parse(params);
};
const getEnvironmentSlug = (node)=>{
    const settings = getAppSettings(node);
    return settings.environmentSlug;
};
// helper for unbranding a value at runtime
function unbrand(value) {
    return value;
}
/** Isomorphic get me the appSettings function */ const getAppSettings = (node)=>{
    const root = getGeneratingRoot(node);
    if (root.type == "FullServerEnvironmentRoot" || root.type == "ReadOnlySchemaRoot" || root.type?.endsWith("TestRoot")) {
        return root.settings;
    } else if (isLiveRoot(root)) {
        return assert(root.settings.get(), "app settings not yet loaded for getting from LiveRoot");
    } else if ("appSettings" in (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node) && (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node).appSettings) {
        return (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node).appSettings;
    } else {
        throw new Error(`Unrecognized root type for getting the app settings from: ${root.type ?? root}`);
    }
};
/**
 * Simple helper function to get the file extension for code files based on the `typescript` property from `AppSettings`.
 */ const getCodeScriptExtension = (node)=>{
    const settings = getAppSettings(node);
    return settings.canGenerateTypeScriptFiles ? "ts" : "js";
};
/**
 * Generate a new object with the keys and values of the given object swapped.
 * @example
 * ```ts
 * const newObject = setMapKeysToValues({
 *   a: "aa",
 *   b: "bb",
 *   c: "cc",
 * });
 * console.log(newObject);
 * // {
 * //   aa: "a",
 * //   bb: "b",
 * //   cc: "c",
 * // }
 * ```
 */ const setMapKeysToValues = (obj)=>{
    return Object.entries(obj).reduce((a, [key, value])=>({
            ...a,
            [value]: key
        }), {});
};
/**
 * Simple helper function to only change the filename in a given path without changing the file extension. Example:
 * ```ts
 * changeFilenameInPath("path/to/file.txt", "newFilename");
 * // "path/to/newFilename.txt"
 * ```
 */ const changeFilenameInPath = (filePath, newFilename)=>{
    const splittedPaths = filePath.split("/");
    const filenameWithExtension = splittedPaths[splittedPaths.length - 1];
    const extension = filenameWithExtension?.split(".").pop();
    return `${splittedPaths.slice(0, splittedPaths.length - 1).join("/")}/${newFilename}.${extension}`;
};
function* maybeYield(value) {
    if (value instanceof Promise) {
        return yield value;
    } else {
        return value;
    }
}
/**
 * Returns a string that combines the namespace and the apiIdentifier.
 *
 * Example:
 * ```ts
 * getNamespacedApiIdentifier(["namespace1", "namespace2"], "apiIdentifier");
 * // Returns "namespace1/namespace2/apiIdentifier"
 * ```
 */ const getNamespacedApiIdentifier = (namespace, apiIdentifier)=>{
    if (lodash_compact__WEBPACK_IMPORTED_MODULE_3___default()(namespace).length === 0) return apiIdentifier;
    return `${namespace.join("/")}/${apiIdentifier}`;
};
const separateNamespacedApiIdentifier = (namespacedApiIdentifier)=>{
    const parts = namespacedApiIdentifier.split("/");
    const apiIdentifier = parts[parts.length - 1];
    return {
        namespace: parts.slice(0, -1),
        apiIdentifier
    };
};
const caseInsensitiveAlphabeticalSorter = (a, b)=>{
    const aLowerCase = a.toLowerCase();
    const bLowerCase = b.toLowerCase();
    if (aLowerCase === bLowerCase) {
        // Same letters with different case, sort normally with capitals first
        return a > b ? 1 : -1;
    }
    return aLowerCase > bLowerCase ? 1 : -1;
};
// Manually disallow cancelling plan for https://admin.gadget.dev/team/11498
const DisableCloseAccountTeamIds = (/* unused pure expression or super */ null && ([
    "11498"
]));
/**
 * The latest and greatest source of truth for all fields that should be filtered out of logs search results.
 * If you're looking to add a new field to the blocklist, please add it here.
 */ const logsSearchFieldBlocklist = (/* unused pure expression or super */ null && ([
    "__typename",
    "action",
    "activity",
    "app_logs_service",
    "application_id",
    "area",
    "attributedToClient",
    "attributedToUserland",
    "causedByClient",
    "causedByUserland",
    "code",
    "commandKey",
    "conditionKey",
    "connectionKey",
    "connectionName",
    "contextID",
    "environmentId",
    "environment_id",
    "error_cause_stack",
    "error_stack",
    "expose",
    "exposeToClient",
    "exposeToSandbox",
    "fieldIdentifier",
    "host",
    "hostname",
    "inputValue",
    "isProductionEnv",
    "isRemoteError",
    "label",
    "logged",
    "modelKey",
    "pid",
    "platform_level",
    "reqId",
    "requestID",
    "resource",
    "rpcMessageID",
    "serverRole",
    "sessionID",
    "signal",
    "source",
    "sourceIdentifier",
    "span_id",
    "sql",
    "storageType",
    "storedValue",
    "time",
    "trace_flags",
    "transitType",
    "userVisible",
    "userspaceLogLevel",
    "workerID",
    "workerPid"
]));
const ggtDevCommand = (appSettings, environmentSlug)=>{
    let command = `ggt dev ./${appSettings.applicationSlug} --app=${appSettings.applicationSlug}`;
    if (appSettings.multiEnvironmentEnabled) {
        command += ` --env=${environmentSlug}`;
    }
    if (false) {}
    return command;
};


/***/ }),

/***/ 98706:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H2: () => (/* binding */ doesVersionSupportShopifySyncOnlyFields),
/* harmony export */   SL: () => (/* binding */ doesVersionSupportNamespace),
/* harmony export */   U0: () => (/* binding */ doesVersionSupportGadgetVitePlugin),
/* harmony export */   Vh: () => (/* binding */ getFastifyVersion),
/* harmony export */   Z2: () => (/* binding */ latestConstraint),
/* harmony export */   f_: () => (/* binding */ secondLatestReleasedVersion),
/* harmony export */   gu: () => (/* binding */ doesVersionSupportModelFieldsInActionParamsType),
/* harmony export */   h$: () => (/* binding */ doesVersionSupportSourceControl),
/* harmony export */   hF: () => (/* binding */ edgeConstraint),
/* harmony export */   pv: () => (/* binding */ labelForConstraint),
/* harmony export */   qD: () => (/* binding */ latestVersion),
/* harmony export */   rv: () => (/* binding */ AvailableVersions),
/* harmony export */   tu: () => (/* binding */ getNodeVersion),
/* harmony export */   ur: () => (/* binding */ doesVersionSupportHydratedSandboxTypes)
/* harmony export */ });
/* unused harmony exports FRAMEWORK_VERSION_CONSTRAINTS, edgeVersion, AvailableVersionNames, getLinuxDistroName, latestVersionSatisfyingConstraint, constraintForLabel, AvailableV1Versions */
/* harmony import */ var compare_versions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11671);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68487);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_memoize__WEBPACK_IMPORTED_MODULE_1__);



// To future traveler who want to add or modify the framework version:
// If the change you are making involves breaking changes to the editor, and you think the change will affect other framework versions,
// go to `EditorVersion.ts` to bump the editor version. It will notify all active editors to reload the page.
const FRAMEWORK_VERSION_CONSTRAINTS = (/* unused pure expression or super */ null && ([
    "^0.1.0",
    "^0.2.0",
    "^0.3.0",
    "^0.3.1",
    "^1.0.0",
    "^1.1.0",
    "^1.2.0",
    "^1.3.0",
    "^1.4.0",
    "^1.5.0"
]));
const AvailableVersions = [
    {
        constraint: "^0.1.0",
        name: "v0.1",
        released: true,
        description: "Node 16.20, Fastify 3",
        nodeVersion: "16",
        fastifyVersion: "3",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^0.2.0",
        name: "v0.2",
        released: true,
        description: "Node 18.15, Fastify 3",
        nodeVersion: "18",
        fastifyVersion: "3",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^0.3.0",
        name: "v0.3",
        released: true,
        description: "Node 20.9, Fastify 4",
        nodeVersion: "20",
        fastifyVersion: "4",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^0.3.1",
        name: "v0.3.1",
        released: true,
        description: "Node 20.9, Fastify 4, support for Shopify webhook disabling",
        nodeVersion: "20",
        fastifyVersion: "4",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^1.0.0",
        name: "v1.0.0",
        released: true,
        description: "Node 20.9, Fastify 4, support for source control and multi-environment",
        nodeVersion: "20",
        fastifyVersion: "4",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^1.1.0",
        name: "v1.1.0",
        released: true,
        beta: false,
        description: "Node 20.12, Fastify 4",
        nodeVersion: "20",
        fastifyVersion: "4",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^1.2.0",
        name: "v1.2.0",
        released: true,
        beta: false,
        description: "Node 20.12, Fastify 4",
        nodeVersion: "20",
        fastifyVersion: "4",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^1.3.0",
        name: "v1.3.0",
        released: true,
        description: "Node 20.12, Fastify 4",
        nodeVersion: "20",
        fastifyVersion: "4",
        distroName: "Debian Bullseye"
    },
    {
        constraint: "^1.4.0",
        name: "v1.4.0",
        released: true,
        description: "Node 22.15, Fastify 4",
        nodeVersion: "22",
        fastifyVersion: "4",
        distroName: "Debian Bookworm"
    },
    {
        constraint: "^1.5.0",
        name: "v1.5.0",
        released: false,
        description: "Node 22.15, Fastify 4",
        nodeVersion: "22",
        fastifyVersion: "4",
        distroName: "Debian Bookworm"
    }
];
const latestVersion = lodash_memoize__WEBPACK_IMPORTED_MODULE_1___default()(()=>AvailableVersions.findLast((version)=>version.name != "edge" && version.released));
const secondLatestReleasedVersion = lodash_memoize__WEBPACK_IMPORTED_MODULE_1___default()(()=>{
    const releasedVersions = AvailableVersions.filter((version)=>version.name != "edge" && version.released);
    if (releasedVersions.length < 2) {
        throw new Error("Not enough released versions to determine second latest");
    }
    return releasedVersions[releasedVersions.length - 2];
});
const edgeVersion = lodash_memoize__WEBPACK_IMPORTED_MODULE_1___default()(()=>AvailableVersions.at(-1));
const AvailableVersionNames = AvailableVersions.map((version)=>version.name);
const latestConstraint = lodash_memoize__WEBPACK_IMPORTED_MODULE_1___default()(()=>latestVersion().constraint);
const edgeConstraint = lodash_memoize__WEBPACK_IMPORTED_MODULE_1___default()(()=>edgeVersion().constraint);
const labelForConstraint = (constraint)=>lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(AvailableVersions, {
        constraint: constraint
    })?.name ?? constraint;
const doesVersionSupportSourceControl = (constraint)=>{
    return (0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(constraint, ">=1.0.0");
};
const doesVersionSupportNamespace = (constraint)=>{
    return (0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(constraint, ">=1.1.0");
};
const doesVersionSupportGadgetVitePlugin = (constraint)=>{
    return (0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(constraint, ">=1.2.0");
};
const doesVersionSupportModelFieldsInActionParamsType = (constraint)=>{
    return (0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(constraint, ">=1.3.0");
};
const doesVersionSupportHydratedSandboxTypes = (constraint)=>{
    return (0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(constraint, ">=1.4.0");
};
const doesVersionSupportShopifySyncOnlyFields = (constraint, shopifyApiVersion)=>{
    return (0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(constraint, ">=1.5.0") && shopifyApiVersion >= "2025-04";
};
const getFastifyVersion = (constraint)=>{
    return lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(AvailableVersions, (version)=>(0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(version.constraint, constraint))?.fastifyVersion ?? "4";
};
const getNodeVersion = (constraint)=>{
    return lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(AvailableVersions, (version)=>(0,compare_versions__WEBPACK_IMPORTED_MODULE_2__/* .satisfies */ .ib)(version.constraint, constraint))?.nodeVersion ?? "20";
};
const getLinuxDistroName = (constraint)=>{
    return find(AvailableVersions, (version)=>satisfies(version.constraint, constraint))?.distroName ?? "Debian Bullseye";
};
const latestVersionSatisfyingConstraint = (constraint)=>{
    return AvailableVersions.findLast((version)=>satisfies(version.constraint, constraint));
};
const constraintForLabel = (label)=>find(AvailableVersions, (item)=>item.name === label)?.constraint;
const AvailableV1Versions = AvailableVersions.filter((version)=>doesVersionSupportSourceControl(version.constraint));


/***/ }),

/***/ 27937:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ Heading)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);

const Heading = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)("h1", ({ $theme })=>({
        ...$theme.typography.heading,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 57142:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: () => (/* binding */ CenteredSpin)
/* harmony export */ });
/* unused harmony export DelayedCenteredSpin */
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8928);
/* harmony import */ var baseui_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60307);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



/** Renders a spinner that centers itself horizontally and vertically in the parent container */ const CenteredSpin = (props)=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            paddingLeft: $theme.sizing.scale600,
            paddingRight: $theme.sizing.scale600,
            paddingTop: $theme.sizing.scale600,
            paddingBottom: $theme.sizing.scale600,
            display: "flex",
            flexDirection: "column",
            gap: $theme.sizing.scale600,
            alignItems: "center",
            justifyContent: "center"
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_spinner__WEBPACK_IMPORTED_MODULE_2__/* .StyledSpinnerNext */ .Mg, {
        $size: baseui_spinner__WEBPACK_IMPORTED_MODULE_3__/* .SIZE */ .S.large
    }), props?.children));
};
const DelayedCenteredSpin = (props)=>{
    const [showSpinner, setShowSpinner] = useState(false);
    const delay = props.delay ?? 0;
    useEffect(()=>{
        const timer = setTimeout(()=>{
            setShowSpinner(true);
        }, delay ?? 0);
        return ()=>clearTimeout(timer);
    }, [
        delay
    ]);
    return showSpinner ? /*#__PURE__*/ React.createElement(CenteredSpin, null) : null;
};


/***/ }),

/***/ 57907:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: () => (/* binding */ DebugDisplay),
/* harmony export */   n: () => (/* binding */ ErrorDisplay)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68689);
/* harmony import */ var _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29196);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15318);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89944);
/* harmony import */ var baseui_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92908);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18844);
/* harmony import */ var fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27621);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isError__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17462);
/* harmony import */ var lodash_isString__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81724);
/* harmony import */ var state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73895);











const ReactJson = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Ay)({
    resolved: {},
    chunkName () {
        return "react18-json-view";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: ()=>Promise.all(/* import() | react18-json-view */[__webpack_require__.e(4258), __webpack_require__.e(528)]).then(__webpack_require__.bind(__webpack_require__, 34258)),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (true) {
            return /*require.resolve*/(34258);
        }
        return eval('require.resolve')("react18-json-view");
    }
});
const Pre = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .styled */ .I4)("pre", ({ $theme })=>({
        fontFamily: _gadgetinc_widgets_src_EditTheme__WEBPACK_IMPORTED_MODULE_8__/* .monoFontFamily */ .DE,
        overflow: "auto",
        paddingLeft: $theme.sizing.scale300,
        paddingRight: $theme.sizing.scale300,
        paddingTop: $theme.sizing.scale300,
        paddingBottom: $theme.sizing.scale300,
        marginBottom: $theme.sizing.scale400,
        borderRadius: $theme.borders.radius200
    }));
const ErrorDisplay = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .c6)();
    let output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(Pre, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label3 */ .u3, {
        $style: {
            color: $theme.colors.negative500
        }
    }, (0,state_trees_src_utils__WEBPACK_IMPORTED_MODULE_6__/* .errorMessage */ .gJ)(props.error)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(baseui_typography__WEBPACK_IMPORTED_MODULE_9__/* .Label4 */ .Bz, {
        $style: {
            color: $theme.colors.negative500
        }
    }, "stack" in props.error ? props.error.stack : "<stack unknown>"), props.extra && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(DebugDisplay, {
        data: props.extra
    }));
    if (props.error.graphQLErrors) {
        const errorWithRemedy = lodash_find__WEBPACK_IMPORTED_MODULE_2___default()(props.error.graphQLErrors, "extensions.remedy");
        if (errorWithRemedy) {
            // This can't be null given the above `find` can only give us a truthy value if it is set
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const remedy = errorWithRemedy.extensions.remedy;
            output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, null, output, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_10__/* .Link */ .N, {
                href: remedy.href
            }, remedy.text));
        }
    }
    return output;
};
const DebugDisplay = (props)=>{
    const [css] = (0,baseui__WEBPACK_IMPORTED_MODULE_7__/* .useStyletron */ .c6)();
    let output;
    if (lodash_isError__WEBPACK_IMPORTED_MODULE_3___default()(props.data)) {
        output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
            error: props.data
        });
    } else {
        let jsonString;
        try {
            if (lodash_isString__WEBPACK_IMPORTED_MODULE_4___default()(props.data)) {
                output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("code", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("pre", null, props.data));
            } else {
                let json;
                if (props.data) {
                    jsonString = fast_safe_stringify__WEBPACK_IMPORTED_MODULE_1___default()(Object.prototype.hasOwnProperty.call(props.data, "toJSON") ? props.data.toJSON() : props.data);
                    json = JSON.parse(jsonString ?? "{}");
                } else {
                    json = String(props.data);
                }
                output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ReactJson, {
                    src: json,
                    collapsed: 2,
                    collapseStringsAfterLength: 100
                });
            }
        } catch (e) {
            output = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement(ErrorDisplay, {
                error: e,
                extra: {
                    json: jsonString
                }
            });
        }
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_5__.createElement("div", {
        className: css({
            maxWidth: "1000px",
            ...props.$style
        })
    }, output);
};


/***/ }),

/***/ 79175:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  H: () => (/* binding */ ErrorNavBar),
  M: () => (/* binding */ NotFound)
});

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(15530);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(79638);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(36129);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx + 2 modules
var GadgetLogo = __webpack_require__(28524);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(89944);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
;// ./src/components/MarketingButton.tsx


const MarketingButton = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    return /*#__PURE__*/ react.createElement("button", {
        onClick: props.onClick,
        className: css({
            cursor: "pointer",
            display: "inline-block",
            WebkitBoxPack: "start",
            justifyContent: "flex-start",
            flexWrap: "nowrap",
            alignItems: "center",
            border: "2px solid #2525cf",
            borderRadius: "6px",
            transition: "150ms",
            fontFamily: "Inconsolata,monospace",
            textAlign: "left",
            backgroundColor: "#e2e2e2",
            color: "#0b171e",
            borderColor: "#919191",
            boxShadow: "inset 0 3px 0 0 #f1f1f1,inset 0 -4px 0 0 #ababab",
            padding: "13px 20px 15px",
            fontSize: "19px",
            ":hover": {
                outline: "0",
                paddingTop: "14px",
                paddingBottom: "14px",
                borderColor: "#7c7c7c",
                boxShadow: "inset 0 2px 0 0 #ababab,inset 0 -2px 0 0 #f1f1f1"
            },
            ":active": {
                outline: "0",
                paddingTop: "15px",
                paddingBottom: "13px",
                borderColor: "#636363",
                boxShadow: "inset 0 4px 0 0 #f1f1f1,inset 0 0 0 0 #fff"
            },
            ...props.$style
        })
    }, props.children);
};
/* harmony default export */ const components_MarketingButton = (MarketingButton);

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/DropdownMenu.tsx
var DropdownMenu = __webpack_require__(27202);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(72919);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(50182);
;// ../@gadgetinc/widgets/src/icons/LogoutIcon.tsx


const LogoutIcon = (props)=>/*#__PURE__*/ react.createElement(styled_components/* Svg */.B, {
        viewBox: "0 0 14 14",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M7.00015 0.600006C5.63752 0.600006 4.37791 1.03658 3.34494 1.76355C3.28762 1.80383 3.2388 1.85501 3.20127 1.91417C3.16373 1.97332 3.13821 2.03929 3.12617 2.1083C3.11413 2.17732 3.1158 2.24803 3.13108 2.3164C3.14637 2.38477 3.17497 2.44946 3.21525 2.50678C3.25554 2.56409 3.30672 2.61291 3.36587 2.65045C3.42503 2.68799 3.49099 2.71351 3.56001 2.72555C3.62902 2.73759 3.69974 2.73592 3.76811 2.72064C3.83648 2.70535 3.90117 2.67675 3.95848 2.63646C4.82311 2.02797 5.86464 1.66667 7.00015 1.66667C9.9519 1.66667 12.3335 4.04825 12.3335 7.00001C12.3335 9.95176 9.9519 12.3333 7.00015 12.3333C5.86464 12.3333 4.82311 11.972 3.95848 11.3635C3.84273 11.2822 3.69939 11.2501 3.56001 11.2745C3.42063 11.2988 3.29661 11.3775 3.21525 11.4932C3.13389 11.609 3.10185 11.7523 3.12617 11.8917C3.15049 12.0311 3.22919 12.1551 3.34494 12.2365C4.37791 12.9634 5.63752 13.4 7.00015 13.4C10.5284 13.4 13.4002 10.5283 13.4002 7.00001C13.4002 3.47176 10.5284 0.600006 7.00015 0.600006ZM2.72307 4.32813C2.58451 4.33226 2.453 4.39017 2.3564 4.48959L0.269941 6.57605C0.204601 6.62589 0.151662 6.69016 0.115255 6.76383C0.0788482 6.83751 0.0599582 6.9186 0.060059 7.00078C0.0601598 7.08297 0.0792489 7.16401 0.115836 7.2376C0.152424 7.31119 0.205521 7.37532 0.270983 7.42501L2.3564 9.51042C2.40554 9.56161 2.46441 9.60247 2.52954 9.63063C2.59468 9.65878 2.66478 9.67365 2.73573 9.67437C2.80669 9.67509 2.87707 9.66165 2.94277 9.63483C3.00846 9.60801 3.06814 9.56835 3.11832 9.51817C3.16849 9.468 3.20815 9.40832 3.23497 9.34262C3.26179 9.27693 3.27524 9.20654 3.27452 9.13559C3.27379 9.06463 3.25892 8.99453 3.23077 8.9294C3.20262 8.86426 3.16175 8.8054 3.11057 8.75626L1.88765 7.53334H7.53348C7.60416 7.53434 7.67432 7.52128 7.73991 7.49493C7.80549 7.46857 7.86518 7.42945 7.91551 7.37982C7.96584 7.3302 8.00581 7.27107 8.03309 7.20586C8.06037 7.14066 8.07441 7.07069 8.07441 7.00001C8.07441 6.92933 8.06037 6.85935 8.03309 6.79415C8.00581 6.72894 7.96584 6.66981 7.91551 6.62019C7.86518 6.57056 7.80549 6.53144 7.73991 6.50508C7.67432 6.47873 7.60416 6.46567 7.53348 6.46667H1.88765L3.11057 5.24376C3.18763 5.16884 3.24027 5.07239 3.26158 4.96705C3.2829 4.86171 3.27189 4.75238 3.23 4.6534C3.18811 4.55442 3.1173 4.47041 3.02684 4.41237C2.93638 4.35432 2.8305 4.32496 2.72307 4.32813Z",
        fill: "black"
    }));

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(92908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/compact.js
var compact = __webpack_require__(3794);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(10608);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-gravatar@2.6.3_react@0.0.0-experimental-4ead6b530/node_modules/react-gravatar/dist/index.js
var dist = __webpack_require__(45692);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// ./src/components/auth/UserDropdown.tsx








const UserDropdown = (0,es/* observer */.PA)((props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement(Row/* Row */.f, {
        $gap: $theme.sizing.scale200,
        className: css({
            ...props.$style
        })
    }, /*#__PURE__*/ react.createElement(DropdownMenu/* DropdownMenu */.r, {
        fullWidth: true,
        items: compact_default()([
            {
                label: /*#__PURE__*/ react.createElement(Row/* Row */.f, {
                    $gap: $theme.sizing.scale400
                }, /*#__PURE__*/ react.createElement(LogoutIcon, null), "Logout"),
                onSelect: ()=>window.location.href = `${rootURL}/auth/logout`
            }
        ]),
        overrides: props.dropdownOverrides,
        overrideArrowDirection: props.overrideArrowDirection
    }, /*#__PURE__*/ react.createElement(Row/* Row */.f, {
        $gap: $theme.sizing.scale300
    }, /*#__PURE__*/ react.createElement((dist_default()), {
        email: props.userEmail,
        size: 16,
        rating: "pg",
        default: "identicon",
        className: css({
            ...(0,utils/* expandBorderRadii */.iw)("50%")
        })
    }), /*#__PURE__*/ react.createElement(typography/* LabelSmall */.ED, {
        $style: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    }, props.userEmail))));
});

;// ./src/components/chrome/NotFound.tsx






const ErrorNavBar = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    const logoProps = {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            height: "46px",
            cursor: "pointer"
        })
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            position: "absolute",
            top: "0",
            left: "0",
            height: 53,
            paddingBottom: "30px",
            paddingTop: "32px",
            paddingLeft: "40px",
            paddingRight: "40px"
        })
    }, props.logoOnly ? /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoMark */.V, logoProps) : /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoType */.w, logoProps), props.showButtons ? /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignContent: "center",
            alignItems: "center"
        })
    }, /*#__PURE__*/ react.createElement("a", {
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/login`;
        },
        className: css({
            cursor: "pointer",
            fontFamily: "Inconsolata,monospace",
            fontWeight: 500,
            fontSize: $theme.sizing.scale650
        })
    }, "Login"), /*#__PURE__*/ react.createElement(components_MarketingButton, {
        $style: {
            height: "47px",
            marginLeft: "32px",
            backgroundColor: "#4242fc",
            borderColor: "#11118f",
            color: "#fff",
            padding: "11px 16px 13px 16px",
            fontSize: "18px",
            boxSizing: "border-box",
            boxShadow: "inset 0 3px 0 0 #7575ff,inset 0 -4px 0 0 #2b2bd9",
            ":hover": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#11118f",
                boxShadow: "inset 0 2px 0 0 #2b2bd9, inset 0 -2px 0 0 #7575ff"
            },
            ":active": {
                paddingTop: "11px",
                paddingBottom: "11px",
                borderColor: "#030347",
                boxShadow: "inset 0 4px 0 0 #7575ff"
            }
        },
        onClick: ()=>{
            window.location.href = `${rootURL}/auth/signup`;
        }
    }, "Sign Up")) : /*#__PURE__*/ react.createElement("div", null, props.user && /*#__PURE__*/ react.createElement(UserDropdown, {
        userEmail: props.user
    })));
};
const NotFound = (props)=>{
    const [_, $theme] = (0,styled/* useStyletron */.c6)();
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement("div", {
        style: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden"
        }
    }, /*#__PURE__*/ react.createElement(Column/* Column */.V, {
        $gap: $theme.sizing.scale600,
        $style: {
            alignItems: "center"
        }
    }, /*#__PURE__*/ react.createElement(Row/* Row */.f, null, /*#__PURE__*/ react.createElement("span", {
        style: {
            ...$theme.typography.MonoHeadingSmall,
            fontSize: "24px",
            fontWeight: 700
        }
    }, "404: Page not found")), /*#__PURE__*/ react.createElement(Row/* Row */.f, null, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        onClick: props.onBackToGadget ?? function() {
            window.location.href = rootURL;
        }
    }, "Back to Gadget"))));
};


/***/ }),

/***/ 2963:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ StillSettingUp)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15530);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4516);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96464);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36205);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);



const StillSettingUp = ()=>{
    const [css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: css({
            display: "flex",
            padding: $theme.sizing.scale1600,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Column */ .V, {
        $gap: $theme.sizing.scale800
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .PageTitle */ .s, {
        $style: {
            fontSize: "32px",
            fontWeight: 700
        }
    }, "Still setting up", /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__/* .EllipsisSpin */ .Gf, null)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .n, null, "This app isn't available yet because it is still setting up. Please try again in a few moments.")));
};


/***/ }),

/***/ 25956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ EmptyStateCard)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79638);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72919);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15530);
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36205);
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27937);




const EmptyStateCard = (props)=>{
    const [_, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .f, {
        $style: {
            alignItems: props.fullSize ? "stretch" : "center",
            justifyContent: "center",
            flex: "1",
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .marginUtil */ .nO)(props.noMargin ? 0 : $theme.sizing.scale300)
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_4__/* .Column */ .V, {
        $gap: props.$gap ?? $theme.sizing.scale800,
        $style: {
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .expandBorderRadii */ .iw)($theme.borders.radius200),
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .paddingUtil */ .Kl)(props.slimPadding ? $theme.sizing.scale800 : $theme.sizing.scale1000),
            ...(0,_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_3__/* .expandBaseWebBorder */ ._Y)({
                borderWidth: "1px",
                borderStyle: "dashed",
                borderColor: $theme.colors.borderOpaque
            }),
            alignItems: "center",
            justifyContent: "center",
            maxWidth: props.maxWidth,
            flex: props.fullSize ? 1 : undefined,
            ...props.$style
        }
    }, props.title && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Heading__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .D, {
        $style: {
            textAlign: "center"
        }
    }, props.title), "message" in props && props.message && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .n, {
        $style: {
            textAlign: "center"
        }
    }, props.message), "children" in props && props.children, props.actions && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .f, {
        $gap: $theme.sizing.scale500
    }, props.actions)));
};


/***/ }),

/***/ 73029:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I: () => (/* binding */ PaymentRequiredCard)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36129);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _editor_EmptyStateCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25956);



const PaymentRequiredCard = ({ email })=>{
    const rootURL =  false ? 0 : "https://app.gadget.dev";
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_editor_EmptyStateCard__WEBPACK_IMPORTED_MODULE_1__/* .EmptyStateCard */ .X, {
        title: "Sorry, your application is unavailable.",
        message: "Your application will be unavailable until you upgrade to a paid plan.",
        actions: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .$n, {
            $as: "a",
            href: `${rootURL}/auth/billing#plans`,
            target: "_blank"
        }, "Upgrade plan")
    });
};


/***/ }),

/***/ 90555:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+react@7.15.0_react@0.0.0-experimental-4ead6b530/node_modules/@sentry/react/esm/sdk.js
var sdk = __webpack_require__(90927);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(23882);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/modal/Modal.tsx
var Modal = __webpack_require__(62783);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(72919);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(36129);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Link.tsx
var Link = __webpack_require__(68689);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/EditTheme.ts
var EditTheme = __webpack_require__(29196);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(89944);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/base-provider.js
var base_provider = __webpack_require__(59243);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/heading/heading-level.js
var heading_level = __webpack_require__(59964);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(92908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-react@6.0.2_react@0.0.0-experimental-4ead6b530/node_modules/styletron-react/dist/browser.es5.es.js
var browser_es5_es = __webpack_require__(63200);
// EXTERNAL MODULE: ./src/lib/styletronEngine.tsx
var styletronEngine = __webpack_require__(76880);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.13.2/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(97072);
;// ./src/components/edit/editor/panel/hooks.ts


let id = 0;
const semaphores = mobx_esm.observable.map();
const semaphoreTaken = (key)=>{
    return !!semaphores.get(key);
};
const useSemaphore = (key)=>{
    const me = react.useMemo(()=>id++, []);
    // we use a react state here so that we can set something and trigger a rerender
    const [hasSemaphore, setHasSemaphore] = react.useState(false);
    react.useEffect(()=>{
        if (semaphores.get(key) == undefined) {
            semaphores.set(key, me);
        }
        if (semaphores.get(key) == me) {
            setHasSemaphore(true);
        }
        return ()=>{
            if (semaphores.get(key) == me) {
                semaphores.delete(key);
            }
        };
    }, [
        key,
        me,
        setHasSemaphore
    ]);
    return hasSemaphore;
};

// EXTERNAL MODULE: ./src/components/chrome/DebugDisplay.tsx
var DebugDisplay = __webpack_require__(57907);
;// ./src/components/chrome/UserFacingErrorHandler.tsx
/* eslint-disable @typescript-eslint/no-misused-promises */ 










const ErrorUISemaphoreKey = "user-facing-error";
const ShowDeveloperErrorInfoKey = "show-dev-errors";
const ErrorModal = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const hasSemaphore = useSemaphore(ErrorUISemaphoreKey); // only let one panel per node open at once
    const [isOpen, setIsOpen] = (0,react.useState)(true);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [isShowingErrorInfo, setShowErrorInfo] = (0,react.useState)( false || !!localStorage.getItem(ShowDeveloperErrorInfoKey));
    const close = ()=>setIsOpen(false);
    const refresh = ()=>{
        setIsLoading(true);
        window.location.reload();
    };
    const showErrorInfo = ()=>{
        setShowErrorInfo(true);
        localStorage.setItem(ShowDeveloperErrorInfoKey, "yes");
    };
    return /*#__PURE__*/ react.createElement(Modal/* Modal */.aF, {
        onClose: close,
        isOpen: isOpen && hasSemaphore,
        autoFocus: false,
        overrides: {
            Dialog: {
                style: {
                    width: "80vw",
                    height: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    ...(0,utils/* expandBaseWebBorder */._Y)({
                        ...$theme.borders.border300,
                        borderColor: $theme.colors.negative300
                    })
                }
            }
        },
        title: /*#__PURE__*/ react.createElement("div", {
            style: {
                color: $theme.colors.negative500
            }
        }, "Oops, there's been an error."),
        footer: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
            kind: "tertiary",
            onClick: close
        }, "Close"), /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
            isLoading: isLoading,
            onClick: refresh
        }, "Refresh"))
    }, /*#__PURE__*/ react.createElement(heading_level/* default */.Ay, null, "This application encountered an unexpected issue. The developer has been alerted. For now, you can close this dialog, or", " ", /*#__PURE__*/ react.createElement(Link/* Link */.N, {
        href: "#",
        onClick: refresh
    }, "refresh"), " ", "the page and try again.", /*#__PURE__*/ react.createElement("div", {
        className: css({
            marginTop: $theme.sizing.scale400
        })
    }, !isShowingErrorInfo && /*#__PURE__*/ react.createElement(Link/* Link */.N, {
        href: "#",
        onClick: showErrorInfo
    }, "Developers: Show Error Info"), isShowingErrorInfo && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(typography/* HeadingSmall */.MD, null, "Error Info"), /*#__PURE__*/ react.createElement("br", null), /*#__PURE__*/ react.createElement(typography/* HeadingXSmall */.en, null, "JS Error"), /*#__PURE__*/ react.createElement(DebugDisplay/* ErrorDisplay */.n, {
        error: props.error
    }), /*#__PURE__*/ react.createElement("br", null)))));
};
const installErrorHandler = ()=>{
    const showError = (error)=>{
        if (semaphoreTaken(ErrorUISemaphoreKey)) return;
        const root = document.createElement("div");
        document.body.appendChild(root);
        react_dom.unstable_createRoot(root).render(/*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.Kq, {
            value: styletronEngine/* styletronEngine */.L,
            debug: styletronEngine/* styletronDebug */.Q
        }, /*#__PURE__*/ react.createElement(base_provider/* default */.A, {
            theme: EditTheme/* EditLightTheme */.CG,
            overrides: {
                AppContainer: {
                    style: {
                        height: "100%"
                    }
                }
            }
        }, /*#__PURE__*/ react.createElement(ErrorModal, {
            error: error
        })))));
    };
    try {
        Error.stackTraceLimit = 50;
    } catch (e) {
    // Not all browsers support this so we don't care if it errors
    }
    window.addEventListener("error", (event)=>{
        showError(event.error);
    });
    window.addEventListener("unhandledrejection", (event)=>{
        let error;
        if (event == null || event.reason == null) {
            error = new Error("Unknown");
        } else {
            if (event.reason instanceof Error) {
                error = event.reason;
            } else {
                // A non-error was rejected, we don't have a trace :(
                // Look in your browser's devtools for more information
                error = new Error(event.reason);
            }
        }
        showError(error);
    });
};

// EXTERNAL MODULE: ./src/lib/flags.ts + 1 modules
var flags = __webpack_require__(92003);
// EXTERNAL MODULE: ./src/lib/global.css
var global = __webpack_require__(84341);
// EXTERNAL MODULE: ./src/components/edit/shared/PaymentRequiredCard.tsx
var PaymentRequiredCard = __webpack_require__(73029);
// EXTERNAL MODULE: ./src/components/chrome/NotFound.tsx + 3 modules
var NotFound = __webpack_require__(79175);
;// ./src/components/chrome/ApplicationUnavailable.tsx





const ApplicationUnavailable = ({ code, userEmail })=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const paymentRequired = !!userEmail && code === "402";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, userEmail && /*#__PURE__*/ react.createElement(NotFound/* ErrorNavBar */.H, {
        logoOnly: true,
        user: userEmail
    }), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ij)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, paymentRequired ? /*#__PURE__*/ react.createElement(PaymentRequiredCard/* PaymentRequiredCard */.I, {
        email: userEmail
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: css({
            ...$theme.typography.MonoHeadingLarge
        })
    }, "Sorry, this application is unavailable."))));
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(50182);
;// ../@gadgetinc/widgets/src/icons/ProhibitionHorizontalIcon.tsx


function ProhibitionHorizontalIcon(props) {
    return /*#__PURE__*/ react.createElement(styled_components/* Svg */.B, {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 1.6C11.52 1.6 14.4 4.48 14.4 8C14.4 11.52 11.52 14.4 8 14.4C4.48 14.4 1.6 11.52 1.6 8C1.6 4.48 4.48 1.6 8 1.6ZM3.2 7.2V8.8H12.8V7.2H3.2Z"
    }));
}

;// ./src/components/chrome/NoPermission.tsx





const NoPermission = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    // Performs a HEAD request at the current page to check if the user has permission to access the page every 5 seconds
    // If the user has permission, the page will automatically reload
    // If the user does not have permission, the page will stay as it is
    const MAX_RETRIES = 1000;
    const INTERVAL = 5000;
    const targetURL = window.location.href.split("?")[0];
    const attempts = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (attempts.current++ >= MAX_RETRIES || document.hidden) return;
            fetch(targetURL, {
                method: "HEAD"
            }).then((response)=>{
                if (response.ok) {
                    window.location.href = targetURL;
                }
            }).catch(()=>{
                return;
            });
        }, INTERVAL);
        return ()=>clearInterval(interval);
    }, [
        attempts,
        targetURL
    ]);
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(NotFound/* ErrorNavBar */.H, {
        logoOnly: true,
        user: props.userEmail
    }), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
            fontFamily: $theme.typography.ParagraphLarge.fontFamily
        })
    }, /*#__PURE__*/ react.createElement("div", {
        className: css({
            fontSize: $theme.sizing.scale700,
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: $theme.sizing.scale500
        })
    }, /*#__PURE__*/ react.createElement(ProhibitionHorizontalIcon, null), props.message ?? "You don’t have permission to view this app"), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            marginTop: $theme.sizing.scale1000,
            marginBottom: $theme.sizing.scale600,
            gap: $theme.sizing.scale500
        })
    }, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        onClick: ()=>window.location.href = `${rootURL}/auth/logout`,
        kind: "secondary"
    }, "Logout"), /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        onClick: ()=>history.back()
    }, "Go Back"))));
};
/* harmony default export */ const chrome_NoPermission = (NoPermission);

// EXTERNAL MODULE: ./src/components/edit/editor/EmptyStateCard.tsx
var EmptyStateCard = __webpack_require__(25956);
;// ./src/components/chrome/PausedEnvironment.tsx




const PausedEnvironment = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ij)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement(EmptyStateCard/* EmptyStateCard */.X, {
        title: "GGT_ENVIRONMENT_PAUSED",
        message: "Contact the developer to resume. If you’re the developer, unpause by opening the environment in the Gadget editor then refresh this page.",
        actions: /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
            $as: "a",
            href: `https://${props.primaryDomain}/edit`,
            target: "_blank"
        }, "Unpause my app")
    }));
};

// EXTERNAL MODULE: ./src/components/chrome/StillSettingUp.tsx
var StillSettingUp = __webpack_require__(2963);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(15530);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/typography/PageTitle.tsx
var PageTitle = __webpack_require__(4516);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(79638);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ExternalLinkIcon.tsx
var ExternalLinkIcon = __webpack_require__(22228);
;// ./src/components/chrome/UndeployedEnvironment.tsx




const UndeployedEnvironment = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const docsURL =  true ? "https://docs.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            padding: $theme.sizing.scale1600,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement(Column/* Column */.V, {
        $gap: $theme.sizing.scale800
    }, /*#__PURE__*/ react.createElement(PageTitle/* PageTitle */.s, {
        $style: {
            fontSize: "32px",
            fontWeight: 700
        }
    }, "This app hasn't been deployed to production."), /*#__PURE__*/ react.createElement(Row/* Row */.f, {
        $gap: $theme.sizing.scale600
    }, /*#__PURE__*/ react.createElement(Button/* Button */.$n, {
        $as: "a",
        kind: Button/* ButtonKind */.ZN.tertiary,
        target: "_blank",
        href: `${docsURL}/guides/deployment`,
        endEnhancer: /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.p, null)
    }, "Learn about deploying"))));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/CircleCheckIcon.tsx
var CircleCheckIcon = __webpack_require__(87823);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/WarningIcon.tsx
var WarningIcon = __webpack_require__(71919);
// EXTERNAL MODULE: ./src/components/chrome/CenteredSpin.tsx
var CenteredSpin = __webpack_require__(57142);
;// ./src/components/chrome/InfoPoller.tsx


const InfoPoller = ()=>{
    (0,react.useEffect)(()=>{
        setTimeout(()=>window.location.reload(), 3000);
    }, []);
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(CenteredSpin/* CenteredSpin */.N, null));
};

;// ./src/components/render/InfoPage.tsx






const InfoPage = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.c6)();
    const iconStyles = {
        $size: 50,
        color: "black",
        backgroundColor: "transparent"
    };
    let iconComponent;
    switch(props.icon){
        case "Error":
            {
                iconComponent = /*#__PURE__*/ react.createElement(WarningIcon/* WarningIcon */.i, iconStyles);
                break;
            }
        case "Success":
            {
                iconComponent = /*#__PURE__*/ react.createElement(CircleCheckIcon/* CircleCheckIcon */.y, iconStyles);
                break;
            }
    }
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ij)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement("div", null, iconComponent), props.message.split("\n").map((text, index)=>/*#__PURE__*/ react.createElement("div", {
            key: index,
            className: css({
                ...$theme.typography.MonoHeadingLarge
            }),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })), props.userEmail && /*#__PURE__*/ react.createElement("a", {
        href: props.logsLink,
        className: css({
            ...$theme.typography.MonoHeadingLarge
        })
    }, props.logsLink), props.poll && /*#__PURE__*/ react.createElement(InfoPoller, null));
};

;// ./src/components/render/InfoApp.tsx















const InfoAppContainer = ()=>{
    const { icon, message, logsLink, code, ggtCode, poll, primaryDomain, userEmail } = window.GadgetInfo;
    if (code === "404") {
        return /*#__PURE__*/ react.createElement(NotFound/* NotFound */.M, null);
    } else if (ggtCode && ggtCode === "GGT_UNDEPLOYED_ENVIRONMENT" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(UndeployedEnvironment, {
            primaryDomain: primaryDomain
        });
    } else if (ggtCode && ggtCode === "GGT_STILL_SETTING_UP" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(StillSettingUp/* StillSettingUp */.i, null);
    } else if (ggtCode && ggtCode === "GGT_ENVIRONMENT_PAUSED" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(PausedEnvironment, {
            primaryDomain: primaryDomain
        });
    } else if (code === "403") {
        return /*#__PURE__*/ react.createElement(chrome_NoPermission, {
            userEmail: userEmail,
            message: message
        });
    } else if (code === "402" || code === "423") {
        return /*#__PURE__*/ react.createElement(ApplicationUnavailable, {
            code: code,
            userEmail: userEmail
        });
    } else {
        return /*#__PURE__*/ react.createElement(InfoPage, {
            icon: icon,
            message: message,
            poll: poll,
            logsLink: logsLink,
            userEmail: userEmail
        });
    }
};
const InfoApp = ()=>/*#__PURE__*/ react.createElement(flags/* FlagsProvider */.nT, {
        flags: flags/* CurrentFlags */.B2
    }, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.Kq, {
        value: styletronEngine/* styletronEngine */.L,
        debug: styletronEngine/* styletronDebug */.Q
    }, /*#__PURE__*/ react.createElement(base_provider/* default */.A, {
        theme: EditTheme/* EditLightTheme */.CG,
        overrides: {
            AppContainer: {
                style: {
                    height: "100%"
                }
            }
        }
    }, /*#__PURE__*/ react.createElement(InfoAppContainer, null))));

;// ./src/info.tsx







if (true) {
    sdk/* init */.T({
        dsn: "https://d043e398111b4b64bb3ba9038b2b3555@o250689.ingest.sentry.io/5352810"
    });
}
installErrorHandler();
react_dom.unstable_createRoot((0,utils/* assert */.vA)(document.getElementById("root"))).render(/*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(InfoApp, null)));


/***/ }),

/***/ 92003:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  B2: () => (/* binding */ CurrentFlags),
  lN: () => (/* binding */ Flag),
  nT: () => (/* binding */ FlagsProvider),
  _P: () => (/* binding */ useFlag),
  D0: () => (/* binding */ useFlags)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/flag@4.4.0_@types+react-dom@17.0.5_@types+react@17.0.4_react-dom@0.0.0-experimental-4ead6b530_5wujmyu4zyhz3ob3w23lepq2am/node_modules/flag/build/index.js
var build = __webpack_require__(51331);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge.js
var merge = __webpack_require__(12495);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.13.2/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(97072);
// EXTERNAL MODULE: ../state-trees/src/assistant/index.ts
var assistant = __webpack_require__(81957);
// EXTERNAL MODULE: ../state-trees/src/type-system/FieldType.ts
var FieldType = __webpack_require__(21687);
;// ../state-trees/src/GadgetFlags.ts



/** Default flag state used for tests in state-trees and web */ const TestFlagDefaultState = {
    features: {
        fieldTypes: {
            [FieldType/* FieldType */.PU.Computed]: false,
            [FieldType/* FieldType */.PU.Color]: false,
            [FieldType/* FieldType */.PU.Money]: false
        },
        darkMode: false,
        ideJSErrorChecking: false,
        actionsAsCode: true,
        fileBasedActions: true,
        computedViews: true,
        codeMirrorShowAllErrors: false,
        codeMirrorHideAllErrors: false,
        shopifyCustomerAuthentication: false,
        computedFieldFiltering: true,
        editorAssistant: true,
        assistantReviewMode: "off",
        assistantManagesTodos: false,
        assistantQuickReplies: false,
        internalTools: true,
        stringEndsWithFilter: true,
        summonApps: false,
        scaffoldApps: false,
        hobbyUnrestricted: false,
        editorAIAutocomplete: false,
        runShopifyAppDeploy: false,
        customizeTemplate: false,
        opsDashboard: false,
        clickhouseLogs: false,
        assistantRoutePreviewScreenshots: false,
        selectiveDBIndexing: false
    },
    internal: {
        eluLimiterMode: "off",
        canarySandbox: false,
        stagingLoki: false,
        rateLimitMode: "enforce",
        requestRateLimitMode: "off",
        databaseQueryRateLimitMode: "off",
        throttleExchange: false,
        edgeFrameworkVersion: false,
        blackholeWebhooks: false,
        selectFrameworkVersionOnCreate: false,
        loadTypesInLanguageServer: false,
        showProblemsInEditor: true,
        cloudflareTurnstile: false,
        usePreparedStatement: false,
        newEnvironmentShard: "main",
        inlineActionExecutor: false,
        useSpotForSandbox: false,
        useSpotForEligibleActions: false,
        searchIndex: true,
        aiPromptVersion: assistant/* MainPromptVersion */.IU,
        assistantModelOverrides: {
            topLevelAgent: "codebase-default",
            baseFastSimple: "codebase-default",
            baseReasoning: "codebase-default",
            baseFastReasoning: "codebase-default",
            dataModeller: "codebase-default",
            codeGenerator: "codebase-default",
            codeEvaluator: "codebase-default",
            changeSelector: "codebase-default",
            codeDiffApplier: "codebase-default",
            summarizer: "codebase-default"
        },
        runWebhookSchemaInference: false,
        liveQueryDiffDisabled: false,
        runWebhookMetafieldValidation: false
    }
};
const ClientSideDefaultFlags = merge_default()({}, TestFlagDefaultState, {});

;// ./src/lib/flags.ts





const { FlagsProvider, Flag, useFlag, useFlags } = (0,build/* default */.Ay)();
const CurrentFlags = (0,mobx_esm.observable)(typeof window === "undefined" ? ClientSideDefaultFlags : window.GadgetFlags);
if (typeof window !== "undefined") {
    /** Utility for setting flag values in tests */ window.mockFlags = (newFlags)=>{
        merge_default()(CurrentFlags, newFlags);
    };
}


/***/ }),

/***/ 76880:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: () => (/* binding */ styletronEngine),
/* harmony export */   Q: () => (/* binding */ styletronDebug)
/* harmony export */ });
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23252);
/* harmony import */ var styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89338);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63200);


const getHydrations = ()=>document.getElementsByClassName("_styletron_hydrate_");
const stylePrefix = "g-";
const styletronEngine = typeof window === "undefined" ? new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A({
    prefix: stylePrefix
}) : new styletron_engine_monolithic__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A({
    hydrate: getHydrations(),
    prefix: stylePrefix
});
const shouldNotDebug =  true || 0;
const styletronDebug = shouldNotDebug ? undefined : new styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .DebugEngine */ .Cd();


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [4574,9243,1498,2160,1816,7112,9453,2483,2619,8264], () => (__webpack_exec__(90555)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);